{
  "recruiting": "Іріктеу",
  "courses": "Курстар",
  "courses-page": {
    "title": "Курстар",
    "create": "Курс жасау",
    "edit": "Курсты өңдеу",
    "empty": "Әлі курстар жоқ",
    "fields": {
      "title": "Атауы",
      "description": "Сипаттама",
      "documents-count": "Құжаттар"
    },
    "headers": {
      "title": "Атауы",
      "description": "Сипаттама",
      "documents": "Құжаттар",
      "actions": "Әрекеттер"
    },
    "dialog": {
      "title-label": "Атауы",
      "description-label": "Сипаттама",
      "documents-label": "Құжаттар",
      "documents-placeholder": "Білім базасының құжаттарын таңдаңыз",
      "save": "Сақтау",
      "cancel": "Бас тарту"
    },
    "messages": {
      "created": "Курс жасалды",
      "updated": "Курс жаңартылды",
      "deleted": "Курс жойылды",
      "error": "Қате орын алды"
    },
    "confirm-delete": "Бұл курсты жойсын ба? Бұл әрекетті қайтару мүмкін емес."
  },
  "ai-study-chat": "AI оқу чаты",
  "ai-study-chat-page": {
    "title": "AI оқу чаты",
    "new-conversation": "Жаңа сөйлесу",
    "empty-sidebar": "Әлі сөйлесулер жоқ",
    "empty-thread": "Оқуды бастау үшін курс немесе сценарий таңдаңыз",
    "untitled": "Жаңа чат",
    "input-placeholder": "Сұрағыңызды теріңіз…",
    "send": "Жіберу",
    "typing": "Көмекші теріп жатыр…",
    "sources": "Дереккөздер ({count})",
    "score": "өзектілік",
    "retry": "Қайталау",
    "failed": "Жіберілмеді",
    "sources-label": "Дереккөздер",
    "copy": "Көшіру",
    "copied": "Көшірілді",
    "search-placeholder": "Сөйлесулерді іздеу",
    "search-empty": "Ештеңе табылмады",
    "empty": {
      "heading": "Оқуға дайын",
      "subtitle": "Курс материалдары туралы кез келген сұрақ қойыңыз — жауапты білім базасынан тауып, дереккөздерін көрсетемін."
    },
    "groups": {
      "today": "Бүгін",
      "yesterday": "Кеше",
      "earlier": "Бұрын"
    },
    "composer": {
      "context": "Контекст:",
      "hint": "Жауаптарды AI материалдарыңыз негізінде жасайды · Жіберу үшін Enter, жаңа жол үшін Shift+Enter"
    },
    "suggestions-fallback": [
      {
        "title": "Материалдарды қорытындылаңыз",
        "subtitle": "Негізгі тезистер"
      },
      {
        "title": "Оқу жоспарын жасаңыз",
        "subtitle": "Қайдан бастау керек"
      },
      {
        "title": "Мені тексеріңіз",
        "subtitle": "Жылдам тексеру"
      },
      {
        "title": "Қарапайым тілде түсіндіріңіз",
        "subtitle": "Терминсіз"
      }
    ],
    "suggestions-fallback-debrief": [
      { "title": "Осы сессияны талдаңыз", "subtitle": "Негізгі қорытындылар" },
      { "title": "Мен нені жақсы жасадым?", "subtitle": "Менің күшті жақтарым" },
      { "title": "Қайда қателестім және неге?", "subtitle": "Өсу нүктелері" },
      { "title": "Келесі сессияда нені жетілдіруім керек?", "subtitle": "Нақты қадамдар" }
    ],
    "suggestions-fallback-progress": [
      { "title": "Нәтижелерім қалай өзгеруде?", "subtitle": "Сессиялар бойынша" },
      { "title": "Менің күшті және әлсіз дағдыларым", "subtitle": "Сессия нәтижелерінен" },
      { "title": "Неге назар аударуым керек?", "subtitle": "Жаттығу басымдығы" },
      { "title": "Алғашқы және соңғы сессияларымды салыстырыңыз", "subtitle": "Не жақсарды" }
    ],
    "quota": {
      "remaining": "{count} хабар қалды",
      "exhausted": "AI чат хабарларыңыз таусылды.",
      "unavailable": "AI чаты сіздің жоспарыңызда қол жетімді емес."
    },
    "new-dialog": {
      "title": "Жаңа сөйлесу",
      "subtitle": "AI жауап беретін дереккөзді таңдаңыз",
      "search": "Іздеу…",
      "search-empty": "Ештеңе табылмады",
      "source-type": "Дереккөз",
      "source-course": "Курс",
      "source-scenario": "Сценарий",
      "source-competency": "Құзыреттілік",
      "pick-course": "Курс таңдаңыз",
      "pick-scenario": "Сценарий таңдаңыз",
      "pick-competency": "Құзыреттілікті таңдаңыз",
      "pick-target": "Барлық сессиялар немесе нақты сессия",
      "all-games": "Барлық сессиялар — менің жетістіктерім",
      "all-games-sub": "Осы құзыреттіліктің нәтижелер динамикасы",
      "back": "Артқа",
      "no-games": "Аяқталған сессиялар жоқ",
      "empty-competencies": "Әзірге аяқталған сессиялар жоқ",
      "empty-competencies-hint": "Құзыретпен байланысты сценарий бойынша сессияны аяқтаңыз — мұнда AI талдауы пайда болады",
      "empty-courses": "Әзірге қолжетімді курстар жоқ",
      "empty-scenarios": "Әзірге қолжетімді сценарийлер жоқ",
      "tag-game": "Сессия",
      "start": "Бастау",
      "cancel": "Бас тарту"
    },
    "stage": {
      "searching": "Материалдардан іздеп жатырмын…",
      "reading": "Дереккөздерді оқып жатырмын…",
      "writing": "Жауап жазып жатырмын…",
      "writing_sources": "{count} үзіндіні талдап жатырмын…",
      "summarizing_short": "Алдыңғы мәнмәтінді реттеуде",
      "searching_short": "Материалдарыңызды іздеуде",
      "reading_short": "Дереккөздерді оқуда",
      "writing_short": "Жауап жазуда",
      "writing_sources_short": "{count} үзіндіні талдауда"
    },
    "errors": {
      "send": "Хабар жіберілмеді. Қайталап көріңіз.",
      "quota": "Хабар лимиті таусылды.",
      "rate_limit": "Сұраулар тым көп. Бір минут күтіп, қайталап көріңіз.",
      "provider_unsupported": "Білім қоры чаты сіздің ұйымыңыздың ағымдағы AI провайдерінде қол жетімді емес.",
      "generic": "Қате орын алды."
    }
  },
  "base_title": "The Reflection",
  "base_title_ru": "SkillsTrainer",
  "404_title": "Бет табылмады ⚠️",
  "404_description": "Өкінішке қарай, сіз іздеген бетті таба алмадық",
  "404_home": "Басты бетке",
  "401_title": "Қол жеткізу тыйым салынған 🔐",
  "401_description": "Сізде бұл бетті қарауға құқық жоқ",
  "401_home": "Басты бетке",
  "changes_saved": "Өзгерістер сақталды",
  "coming_soon": "Бөлім әзірленуде",
  " ": " ",
  "select_date_and_time": "Күні мен уақытын таңдаңыз",
  "select_date": "Күнін таңдаңыз",
  "chat": "Чат",
  "menu": "Мәзір",
  "games": "Сессиялар",
  "tours": "Турлар",
  "library": "Кітапхана",
  "library-video": "Бейне",
  "library-scorm": "Курстар",
  "library-documents": "Құжаттар",
  "scenarios": "Сценарийлер",
  "competencies": "Құзыреттер",
  "competencies-list": "Тізім",
  "skills": "Дағдылар",
  "home": "Басты бет",
  "home_player": "Қатысушы",
  "player": "Қатысушы",
  "home_expert": "Сарапшы",
  "reports-analytics-tours": "Турлар",
  "reports": "Есептер",
  "ranking": "Рейтинг",
  "analytics": "Аналитика",
  "support": "Қолдау",
  "users": "Пайдаланушылар",
  "participants": "Қатысушылар",
  "departments": "Бөлімдер",
  "positions": "Лауазымдар",
  "user-custom-fields": "Теңшелетін өрістер",
  "administration": "Әкімшілендіру",
  "ai-assistants": "AI ассистенттері",
  "ai-profiles": "AI профильдері",
  "ai-connectors": "AI қосылымдары",
  "Audit logs": "Аудит журналдары",
  "organizations": "Ұйымдар",
  "loading": "Жүктелуде...",
  "retry": "Қайталау",
  "previous": "Артқа",
  "next": "Алға",
  "save": "Сақтау",
  "copy": "Көшіру",
  "copy_failed": "Автоматты түрде көшіру мүмкін болмады. Өрістегі мәтінді белгілеп, қолмен көшіріңіз (Ctrl+C немесе ⌘C).",
  "confirm": "Растау",
  "suggest": "Ұсыну",
  "generate": "Генерациялау",
  "cancel": "Болдырмау",
  "close": "Жабу",
  "search": "Іздеу...",
  "accept": "Қабылдау",
  "propose": "Ұсыну",
  "decline": "Бас тарту",
  "send_request": "Сұрау жіберу",
  "assign": "Тағайындау",
  "actions": " ",
  "evaluators": {
    "ai": "AI",
    "expert": "Сарапшы",
    "player": "Қатысушы",
    "manager": "Басшы",
    "head": "Басшы"
  },
  "statistics": {
    "date_from": "Бастап",
    "date_to": "Дейін",
    "competence": "Құзырет",
    "evaluator": "Сараптама",
    "last_games_effectiveness": {
      "effectiveness": "Тиімділік",
      "title": "Сессиялар бойынша тиімділік"
    },
    "skill_trend": {
      "average_score": "Орташа баға",
      "game": "Сессия",
      "score": "Баға",
      "title": "Орташа баға"
    },
    "player_competence_radar": {
      "title": "Құзыреттер статистикасы",
      "top": "Топ 10",
      "players_in_company": "Компаниядағы қатысушылар",
      "by_games": "Сессиялар бойынша аналитика",
      "subtitle": "Қатысушы және компанияның жалпы статистикасы",
      "filter": "Сүзгі",
      "you": "Қатысушы",
      "company": "Компания",
      "average_score": "орташа баға",
      "skills_counted": "{total} ішінен {counted} дағды бойынша"
    }
  },
  "participant": {
    "upcoming_games": "Алдағы сессиялар",
    "for_rank_games": "Бағалау сұрауы"
  },
  "roles": {
    "player": "Қатысушы",
    "admin": "СуперӘкімші (жүйелік)",
    "scoped_admin": "Аға әкімші",
    "observer": "Бақылаушы",
    "captain": "Капитан",
    "expert": "Сарапшы",
    "lead_expert": "Аға сарапшы",
    "manager": "Әкімші",
    "support": "Қолдау",
    "early_access": "Ерте қолжетімділік",
    "head": "Басшы",
    "candidate": "Кандидат"
  },
  "user-status": {
    "active": "Белсенді",
    "inactive": "Бұғатталған",
    "pending": "Растау"
  },
  "pagination": {
    "showing": "Көрсетілді",
    "to": "-",
    "of": "барлығы",
    "entries": "жазба"
  },
  "validator": {
    "required": "Бұл міндетті өріс",
    "library": "Файл өлшемі 500 МБ-тан аз болуы керек",
    "email": "Email дұрыс емес",
    "password": "Құпиясөзде кемінде бір кіші әріп, сан және арнайы символ болуы керек. Ең азы 8 таңба.",
    "confirm": "Құпиясөздер сәйкес емес",
    "at_least": "Кемінде таңдалуы керек",
    "items": "мән",
    "number": "Өрісте сан болуы керек",
    "is_odd": "Сан жұп болуы керек",
    "number_between": "Санды енгізіңіз (аралығы)",
    "number_and": "және",
    "date_range_required": "Аралық міндетті",
    "invalid_date_range": "Аралық дұрыс емес",
    "invalid_date_format": "Күн форматы дұрыс емес",
    "start_date_after_end_date": "Басталу күні аяқталу күнінен бұрын болуы керек",
    "max_180_days": "Ең көбі 180 күн"
  },
  "user": {
    "menu": {
      "settings": "Баптаулар",
      "statistics": "Статистика",
      "logout": "Шығу"
    }
  },
  "theme": {
    "system": "Жүйелік",
    "light": "Ашық",
    "dark": "Қараңғы"
  },
  "error": {
    "default": "Кешіріңіз, қате орын алды. Мамандарымыз мәселені біледі және жақын арада түзетеді.",
    "unauthorized": "Сіздің сессияңыз аяқталды.",
    "contact-support": "Кешіріңіз, қате орын алды. Тех.қолдауға хабарласыңыз",
    "forbidden": "Қол жеткізу тыйым салынған"
  },
  "confirmation": {
    "sure": "Жазбаны жоюды шынымен қалайсыз ба?",
    "sure_return_to_time_scheduling": "Сессияны басталу уақытын келісу кезеңіне қайтарғыңыз келе ме?",
    "sure_restore": "Жазбаны қалпына келтіргіңіз келе ме?",
    "sure_mark_failed": "Ойынды сәтсіз деп белгілеп, барлық бағалаулар мен қатысушылардың хаттамаларын біржола жою керек пе?",
    "success": "Сәтті!",
    "deleted": "Жазба жойылды",
    "failed_marked": "Ойын сәтсіз деп белгіленді",
    "restored": "Жазба қалпына келтірілді",
    "cancel": "Әрекет болдырылмады",
    "yes": "Иә",
    "no": "Жоқ"
  },
  "dashboards": {
    "player": {
      "summary": {
        "welcome": "Қош келдіңіз",
        "progress": "Сіздің жалпы прогресіңіз",
        "stats": {
          "minutes": "Сессиядағы минут",
          "effectiveness": "Тиімділік",
          "completed_games_count": "Сәтті сессиялар",
          "total_games_count": "Барлығы сессия"
        }
      },
      "cards": {
        "players_rating": {
          "title": "Компанияңыздың рейтингі",
          "player": "Қатысушы",
          "effectiveness": "Тиімділік"
        }
      }
    },
    "head": {
      "my_stats": "Менің статистикам",
      "subordinates": "Менің бағыныштыларым",
      "subordinate_stats": "Бағыныштының статистикасы",
      "select_subordinate": "Статистиканы көру үшін бағыныштыны таңдаңыз",
      "no_subordinates": "Бағыныштылар тағайындалмаған"
    }
  },
  "chat-page": {
    "last_game": "Соңғы сессия",
    "chats": "Чаттар",
    "no-chats": "Бос",
    "contacts": "Контактілер",
    "choose": "Контакт таңдаңыз",
    "send": "Жіберу",
    "type": "Хабарыңыз...",
    "no-contacts": "Бос",
    "search": "Іздеу...",
    "start_conversation": "Диалог бастау",
    "start_connecting": "Сол жақтан контакт таңдап, адамдармен сөйлесуді бастаңыз."
  },
  "scenarios-page": {
    "title": "Атауы",
    "export-docx": "Export .docx",
    "copy_title": "Кейсті көшіру",
    "generate_ai_title": "Кейсті AI арқылы генерациялау",
    "organization": "Ұйым",
    "competence": "Құзырет",
    "actions": " ",
    "add": "Сценарий қосу",
    "ai-generate": "AI генерациясы",
    "copy": "Сценарийді көшіру",
    "add_popup": "Сценарий қосу",
    "delete": "Сценарийді жою",
    "edit": "Сценарийді өзгерту",
    "edit_popup": "Сценарийді өзгерту",
    "industries": [
      "FMCG/бөлшек сауда",
      "Фармацевтика",
      "Банктер және финтех",
      "Қонақүйлер және туризм",
      "IT компаниялары/SaaS",
      "Мейрамхана бизнесі/HoReCa",
      "E-commerce/маркетплейстер",
      "Өндіріс/Индустрия 4.0",
      "Логистика және T&L",
      "Телеком",
      "Білім/EdTech",
      "Химиялық өнеркәсіп",
      "Жеткізу тізбегін басқару бағдарламасы",
      "Мемлекеттік сектор/коммерциялық емес ұйымдар"
    ],
    "case_types": [
      "Көшбасшылық және People-Management",
      "Персоналды іріктеу және бағалау",
      "Сату және клиенттік сервис",
      "Келіссөздер және ықпал ету",
      "Қақтығыстарды басқару",
      "Стратегия және орындау"
    ],
    "cases": [
      [
        "SMART/OKR мақсаттарын қою",
        "Дамытушы кері байланыс беру (SBI/COIN)",
        "Делегирлеу",
        "GROW коучингі",
        "Нәтижені бағалау (Performance Review)",
        "Менторлық"
      ],
      [
        "Құзыреттер бойынша сұхбат (CBI)",
        "Аттестация/ассессмент-орталық",
        "Онбординг сессиясы"
      ],
      [
        "Өнім/қызметті классикалық сату",
        "Қарсылықтармен жұмыс",
        "Апселл/кросс-селл",
        "Шағымды өңдеу (претензия)",
        "M-channel сату"
      ],
      [
        "Бюджет/ресурстар туралы ішкікорпоративтік келіссөздер",
        "Клиентпен/жеткізушімен келісімшарт",
        "Дағдарыстық келіссөздер"
      ],
      [
        "Командадағы тұлғааралық қақтығыс",
        "Басшы–бағынышты",
        "Құндылықтар/этика қақтығысы"
      ],
      [
        "Жобалар портфелін приоритизациялау",
        "Өзгерістерді басқару",
        "Тәуекелдерді талдау"
      ]
    ],
    "formats": [
      "1-1",
      "Командалар"
    ],
    "labels": {
      "industry": "Сала",
      "case_type": "Кейс түрі",
      "case": "Кейс",
      "format": "Формат",
      "duration": "Ұзақтығы (минут)",
      "game_vs_ai": "AI-ға қарсы сессия",
      "level": "Қиындық",
      "competence": "Құзырет",
      "description": "Сценарий сипаттамасы",
      "description_hint": "Генерациялағыңыз келетін сценарийді сипаттаңыз (макс. 4000 таңба)"
    },
    "generating_in_progress": "Сценарий генерациялануда, күте тұрыңыз..."
  },
  "analytics-page": {
    "tours-page": {
      "tour": "Тур",
      "full_name": "Қатысушы",
      "games_count": "Сессиялар",
      "team": "Команда",
      "export": "Экспорт",
      "effectiveness": "Тиімділік"
    }
  },
  "report-filters": {
    "department": "Бөлім",
    "position": "Лауазым",
    "employee": "Қызметкер",
    "scenario": "Сценарий",
    "competence": "Құзырет",
    "period": "Кезең",
    "reset": "Тазалау",
    "only-period-competence": "Тек кезең мен құзырет сүзгілері ескеріледі"
  },
  "competencies-page": {
    "title": "Атауы",
    "export-docx": "Export .docx",
    "skills": "Дағдылар",
    "text": "Сипаттама",
    "display_order": "Сұрыптау",
    "ai-assistant": "AI ассистент",
    "language": "Тіл",
    "department": "Бөлім",
    "evaluation-target": "Кімді бағалаймыз?",
    "evaluation-both": "Екі қатысушыны да",
    "evaluation-team-a": "Тек A командасы",
    "evaluation-both-tooltip": "Екі қатысушы да бағаланады — келіссөз сценарийлеріне сай",
    "evaluation-team-a-tooltip": "Тек жетекші бағаланады — кері байланыс форматы",
    "actions": " ",
    "add": "Құзырет қосу",
    "add_popup": "Құзырет қосу",
    "delete": "Құзыретті жою",
    "edit": "Құзыретті өзгерту",
    "edit_popup": "Құзыретті өзгерту"
  },
  "faq-page": {
    "title": "Сұрақтар",
    "question": "Сұрақ",
    "text": "Жауап",
    "is_shared": "Барлық ұйымдарға қолжетімді",
    "actions": " ",
    "visibility": "Көріну",
    "visible_to_all": "Барлық пайдаланушыларға көрінеді",
    "visible_to_managers": "Тек менеджерлерге көрінеді",
    "add": "Сұрақ қосу",
    "add_popup": "Сұрақ қосу",
    "delete": "Сұрақты жою",
    "edit": "Сұрақты өзгерту",
    "edit_popup": "Сұрақты өзгерту"
  },
  "ai-connectors-page": {
    "title": "AI қосылымдары",
    "is_shared": "Барлық ұйымдарға қолжетімді",
    "actions": " ",
    "add": "Қосылым қосу",
    "add_popup": "Қосылым қосу",
    "delete": "Қосылымды жою",
    "edit": "Қосылымды өзгерту",
    "edit_popup": "Қосылымды өзгерту",
    "label": "Атауы",
    "provider": "Провайдер",
    "service": "Сервис",
    "organization": "Ұйым",
    "status": "Мәртебе",
    "region": "Аймақ",
    "endpoint": "Endpoint",
    "secret": "Құпиясөз/Кілт",
    "maxConcurrency": "Қосылымдардың ең көп саны",
    "timeoutSec": "Таймаут",
    "sortOrder": "Сұрыптау реті",
    "config": "Конфигурация",
    "modelPrimary": "Primary моделі",
    "modelLight": "Light моделі",
    "modelLightHint": "Бос болса, light шақырулары primary моделіне барады",
    "folderId": "Folder ID",
    "models": "Модельдер",
    "is_default": "Әдепкі",
    "notes": "Ескертпелер"
  },
  "skills-page": {
    "title": "Атауы",
    "display_order": "Сұрыптау",
    "competence": "Құзырет",
    "text": "Индикаторлар",
    "actions": " ",
    "add": "Дағды қосу",
    "add_popup": "Дағды қосу",
    "delete": "Дағдыны жою",
    "edit": "Дағдыны өзгерту",
    "edit_popup": "Дағдыны өзгерту"
  },
  "departments-page": {
    "title": "Атауы",
    "actions": " ",
    "add": "Бөлім қосу",
    "add_popup": "Бөлім қосу",
    "delete": "Бөлімді жою",
    "edit": "Бөлімді өзгерту",
    "edit_popup": "Бөлімді өзгерту"
  },
  "tours-page": {
    "title": "Атауы",
    "actions": " ",
    "add": "Тур қосу",
    "add_popup": "Тур қосу",
    "delete": "Турды жою",
    "edit": "Турды өзгерту",
    "edit_popup": "Турды өзгерту"
  },
  "library-page": {
    "title": "Атауы",
    "text": "Сипаттама",
    "video": "Бейне",
    "courses": "Курстар",
    "video_link_copy": "Сілтемені көшіру",
    "video_in_process": "Бейне өңделуде...",
    "is_public": "Қатысушыларға қолжетімді",
    "actions": " ",
    "add": "Бейне қосу",
    "add_popup": "Бейне қосу",
    "delete": "Бейнені жою",
    "edit": "Бейнені өзгерту",
    "edit_popup": "Бейнені өзгерту"
  },
  "library-documents-page": {
    "title": "Атауы",
    "actions": " ",
    "add": "Құжат қосу",
    "add_popup": "Құжат қосу",
    "delete": "Құжатты жою",
    "edit": "Құжатты өзгерту",
    "edit_popup": "Құжатты өзгерту",
    "file": "Файл"
  },
  "scorm-page": {
    "title": "Атауы",
    "actions": " ",
    "add": "Курс қосу",
    "loading": "Курс жүктелуде...",
    "add_popup": "Курс қосу",
    "delete": "Курсты жою",
    "edit": "Курсты өзгерту",
    "edit_popup": "Курсты өзгерту",
    "zip_file": "ZIP файл"
  },
  "ai-assistants-page": {
    "external_id": "ID",
    "description": "Сипаттама",
    "actions": " ",
    "add": "Ассистент қосу",
    "add_popup": "Ассистент қосу",
    "delete": "Ассистентті жою",
    "edit": "Ассистентті өзгерту",
    "edit_popup": "Ассистентті өзгерту"
  },
  "ai-prompts-page": {
    "name": "Атауы",
    "content": "Мазмұны",
    "actions": " ",
    "add": "Промпт қосу",
    "add_popup": "Промпт қосу",
    "delete": "Промптты жою",
    "edit": "Промптты өзгерту",
    "edit_popup": "Промптты өзгерту",
    "key": "Слот кілті",
    "model": "Модель",
    "updated_at": "Жаңартылды",
    "custom": "Арнайы",
    "description": "Сипаттама",
    "temperature": "Температура",
    "top_p": "Top P",
    "reasoning_effort": "Ойлау қарқыны",
    "reasoning_effort_default": "Әдепкі",
    "required_placeholders": "Міндетті айнымалылар (мазмұнда болуы керек)",
    "versions": "Нұсқалар тарихы",
    "no_versions": "Әлі нұсқалар жоқ",
    "restore": "Қалпына келтіру",
    "restore_confirm": "Бұл нұсқаны қалпына келтіру керек пе? Оның мазмұны ағымдағы нұсқаға айналады.",
    "restored": "Нұсқа қалпына келтірілді",
    "current_version": "Ағымдағы",
    "author": "Автор",
    "error": "Қате орын алды.",
    "tab_system": "Жүйелік",
    "tab_custom": "Арнайы",
    "system_hint": "Жүйелік промпттарды платформа коды пайдаланады. Оларды жоюға болмайды, бірақ мазмұнын өзгертуге болады.",
    "custom_hint": "Арнайы промпттар құзыреттер мен AI профильдеріне бағалау промптын ауыстыру ретінде тіркеледі.",
    "model_from_code": "кодпен анықталады",
    "model_from_code_hint": "Модельді промптты пайдаланатын код таңдайды; ол промпттың өзінде сақталмайды.",
    "used_by": "Қолданылады",
    "used_by_value": "Құзыреттер: {competencies}, AI профильдері: {profiles}",
    "not_used": "Қолданылмайды",
    "delete_blocked_hint": "Жоюға болмайды: промпт ауыстыру ретінде қолданылады. {usage}",
    "slot_description": {
      "game_eval_negotiation": "PvP сессияларын AI бағалауы: келіссөз",
      "game_eval_feedback": "PvP сессияларын AI бағалауы: кері байланыс",
      "game_eval_vs_ai": "AI-ға қарсы сессияларды AI бағалауы (AI профилінде ауыстыру жоқ болса)",
      "protocol_evaluation": "AI-ға қарсы сессия стенограммасы негізінде сценарий протоколын толтыру",
      "voice_agent": "Дауыс агенті үшін жүйелік промпт",
      "scenario_generation": "Сипаттама негізінде сценарий генерациясы",
      "scenario_card_update": "Сценарий карточкасын AI сипаттамасы негізінде жаңарту",
      "scenario_optimize": "Сценарийдің AI сипаттамасын оңтайландыру",
      "skill_report_analysis": "Дағдылар есебі: талдау қадамы",
      "skill_report_recommendations": "Дағдылар есебі: ұсыныстар қадамы"
    }
  },
  "ai-profiles-page": {
    "name": "Аты",
    "settings": "Баптаулар",
    "temperature": "Қиял деңгейі",
    "demeanor": "Мінезі мен тоны",
    "behavior": "Мінез-құлық, нұсқаулар",
    "background": "Өмірбаяны",
    "supportive_phrases": "Қолдау сөздері",
    "ai_assistant": "AI ассистент",
    "ai_starts_first": "AI бірінші бастайды",
    "first_phrase": "Алғашқы сөз",
    "closing_phrases": "Қорытынды сөздер",
    "voice": "Дауыс",
    "expert_mode": "Сарапшылық режим",
    "custom_demeanor_hint": "Ағымдағы арнайы мінез-құлық",
    "is_shared": "Барлық ұйымдарға қолжетімді",
    "voice_options": {
      "male": "Ер адам",
      "female": "Әйел"
    },
    "demeanor_options": {
      "friendly": {
        "title": "Достық",
        "description": "Әңгімелесуге жеңіл әрі жағымды"
      },
      "critical": {
        "title": "Сыншыл",
        "description": "Кемшіліктер мен жақсартуға болатын тұстарды жиі көрсетеді"
      },
      "empathetic": {
        "title": "Эмпатиялық",
        "description": "Басқалардың сезімдері мен эмоцияларына өте сезімтал"
      },
      "enthusiastic": {
        "title": "Ынталы",
        "description": "Күшті ынта мен жігер танытады"
      },
      "analytical": {
        "title": "Аналитикалық",
        "description": "Логика мен детальды шешуге фокус жасайды"
      },
      "curious": {
        "title": "Қызығушылық танытатын",
        "description": "Жаңа нәрсе білгісі келіп, сұрақ қояды"
      },
      "assertive": {
        "title": "Өжет",
        "description": "Өзіне сенімді"
      },
      "blunt": {
        "title": "Тік",
        "description": "Тікелей, нақты сөйлейді"
      },
      "skeptical": {
        "title": "Скептик",
        "description": "Жаңа шешімдерге сақтықпен қарайды"
      },
      "neutral": {
        "title": "Бейтарап",
        "description": "Теңгерімді және объективті"
      },
      "casual": {
        "title": "Еркін",
        "description": "Еркін, ауызекі тон"
      }
    },
    "placeholders": {
      "name": "Мысалы: Серік (сыпайы және достық)",
      "demeanor": "Мысалы: Достық, сыпайы және ашық...",
      "background": "Мысалы: Екі рет жұмыстан шығарылған...",
      "behavior": "Мысалы: Бөлмейді, белсенді тыңдайды...",
      "first_phrase": "Мысалы: Сәлеметсіз бе! Көңіл-күйіңіз қалай?",
      "closing_phrases": "Мысалы: Уақытымыз аз қалды, сондықтан кездесу қорытындысын тез шығарайық."
    },
    "actions": " ",
    "add": "AI профиль қосу",
    "add_popup": "AI профиль қосу",
    "subtitle": "Сессияда әңгімелесуші қалай көрінеді және қалай естіледі",
    "preview": {
      "title": "Алдын ала қарау",
      "unnamed": "Атауы жоқ",
      "voice": "дауыс {name}",
      "defaultVoice": "әдепкі дауыс",
      "defaultPhoto": "Әдепкі фото",
      "listen": "Дауысты тыңдау",
      "defaultVoiceNotice": "Дауыс сессия басында таңдалады — алдын ала тыңдау мүмкін емес",
      "photoPlaceholder": "Фото осында пайда болады"
    },
    "delete": "AI профильді жою",
    "edit": "AI профильді өзгерту",
    "edit_popup": "AI профильді өзгерту",
    "avatar_hint": "аватар суреті",
    "avatar_save_first": "Аватар жүктеуді қосу үшін алдымен профильді сақтаңыз",
    "avatar_requirements": "Макс. 1 МБ • Ұсынылатын: 1536×1024 • Арақатынасы: 3:2",
    "max_characters": "Ең көбі {max} таңба"
  },
  "games-page": {
    "game-with-ai": "AI-мен сессия",
    "organization": "Ұйым",
    "status": "Мәртебе",
    "failure_reasons": {
        "protocol_not_agreed": "Қатысушылар протоколмен келіспеді",
        "protocol_approval_expired": "Протоколды келісу уақыты аяқталды",
        "annulled": "Сессия болдырылмады",
        "expired": "Сессия уақыты аяқталды",
        "assignment_changed": "Оқыту жүйесінде курс тағайындауы өзгерді"
    },
    "restore": "Қалпына келтіру",
    "play": "Ойнау",
    "meetings_unavailable": "Қатысушылар арасындағы бейнесессиялар уақытша қолжетімсіз. Кейінірек қайталап көріңіз.",
    "import": "Импорт",
    "scenario": "Сценарий",
    "tour": "Тур",
    "game_types": {
      "classic": "Классикалық режим",
      "vs_ai": "AI-ға қарсы сессия",
      "uploaded_recording": "Жазба"
    },
    "upload_recording": {
      "file": "Жазба файлы",
      "file_hint": "Бейне немесе аудио, 1 ГБ-ға дейін",
      "uploaded": "Файл жүктелді",
      "file_too_large": "Файл 1 ГБ-тан үлкен",
      "upload_error": "Файлды жүктеу сәтсіз аяқталды",
      "player": "Қатысушы",
      "rate_both": "Екі қатысушыны да бағалау",
      "second_player": "Екінші қатысушы",
      "open_session": "Сессияны ашу"
    },
    "game_targets": {
      "user": "Қатысушы",
      "position": "Лауазым",
      "department": "Бөлім"
    },
    "number": "Нөмір",
    "start_up_to": "Бастау уақыты (дейін)",
    "start_time": "Басталу уақыты",
    "teamA": "A командасы",
    "teamB": "B командасы",
    "others": "Қатысушылар",
    "actions": " ",
    "edit_results": "Нәтижелерді өзгерту",
    "add": "Сессия қосу",
    "add_popup": "Жаңа сессия",
    "delete": "Сессияны жою",
    "edit": "Сессияны өңдеу",
    "edit_popup": "Сессияны өңдеу",
    "time_scheduling": "Басталу уақытын келісу",
    "return_to_time_scheduling": "Басталу уақытын келісуге қайту",
    "preparation": "Сессияға дайындық",
    "view_scenario": "Сценарийді қарау",
    "protocol": "Протоколды келісу",
    "not_agreed": "Келісілмеген",
    "expert-accept": "Қабылдап, бағалауға өту",
    "expert-decline": "Қабылдамау",
    "hide_ai_results": "AI бағасын жасыру",
    "show_ai_results": "AI бағасын көрсету",
    "mark_failed": "Сәтсіз деп белгілеу",
    "popup": {
      "start_up_to": "Ойнау мерзімі (дейін)",
      "target": "Сессияны кімге тағайындаймыз?",
      "custom_field_value": "«{field}» өрісінің мәні",
      "target_preview_count": "Құрылатын сессиялар: {count}",
      "target_preview_empty": "Бұл топтамаға бірде-бір ойыншы кірмейді — бірде-бір сессия құрылмайды",
      "target_preview_limit_exceeded": "Бұл бір тағайындауда құруға болатыннан көп ({limit} дейін). Тілімді, кейстер санын немесе көшірмелер санын азайтыңыз",
      "copies_per_player": "Ойыншыға әр кейстің көшірмелері",
      "position": "Лауазым",
      "department": "Бөлім",
      "scenario": "Сценарий",
      "optional": "Опционалды, көрсету міндетті емес",
      "protocol_time": "Протокол уақыты",
      "protocol_time_hint": "Минутпен",
      "preparation_time": "Дайындық уақыты",
      "preparation_time_hint": "Минутпен",
      "game_duration": "Ұзақтығы",
      "game_duration_hint": "Минутпен",
      "is_team": "Командалар үшін",
      "is_camera_required": "Камера міндетті",
      "is_self_rated": "Өзін-өзі бағалау мүмкін",
      "is_each_other_rated": "Бір-бірін бағалау мүмкін",
      "is_expert_rated": "Сарапшы бағалауы мүмкін",
      "is_ai_rated": "AI бағалауы мүмкін",
      "show_results": "Нәтижелерді көрсету",
      "automatically": "автоматты түрде",
      "manually": "қолмен",
      "is_public_hint": "Кез келген бақылаушы қосыла алады",
      "is_public": "Ашық сессия",
      "team_a": "A командасы",
      "team_b": "B командасы",
      "player_a": "A қатысушысы",
      "player_b": "B қатысушысы",
      "expert": "Сарапшы",
      "observers": "Бақылаушылар",
      "tour": "Тур",
      "search": "Іздеу...",
      "choose_players": "Қатысушыларды таңдаңыз",
      "choose_expert": "Сарапшыны таңдаңыз",
      "choose_observers": "Бақылаушыларды таңдаңыз",
      "choose_scenario": "Сценарийді таңдаңыз",
      "choose_tour": "Турды таңдаңыз",
      "expert_empty": "Егер таңдалмаса, капитан таңдай алады",
      "captain": "Капитан",
      "": "",
      "protocol": {
        "title": "Протоколды келісу",
        "target": "Шекті мән",
        "await_approval": "Қарсыластың келісімін күтіңіз",
        "await_proposal": "Қарсыластың ұсынысын күтіңіз",
        "questions": "Сіздің командаңызға сұрақтар",
        "questions_a": "A командасының сұрақтары",
        "questions_b": "B командасының сұрақтары",
        "not_agreed": "Келіспеді",
        "not_agreed_confirm": "Сессия сәтсіз аяқталады, нәтижелер есепке алынбайды. Бұл әрекетті кері қайтару мүмкін емес.",
        "not_agreed_done": "Сессия сәтсіз аяқталды."
      },
      "start_time": {
        "title": "Басталу уақыты",
        "must_start_by": "Міндетті түрде бастау керек (дейін)"
      },
      "edit_results": {
        "title": "Нәтижелерді өзгерту"
      },
      "preparation": {
        "title": "Сессияға дайындық",
        "description": "Сессия сипаттамасы",
        "description_team": "Командаға арналған сипаттама",
        "notes": "Сіздің жазбаларыңыз"
      },
      "import": {
        "download_example": "Үлгіні жүктеу",
        "title": "Сессияларды импорттау",
        "button": "Жүктеу",
        "label": "Excel файлы"
      },
      "create_multi_scenario_games_immediately": "Барлық сессиялар бірден құрылады",
      "create_multi_scenario_games_sequentially": "Сессиялар кезекпен құрылады (әрқайсысы сәтті аяқталғаннан кейін)"
    }
  },
  "ai-game": {
    "title": "AI-мен сессия",
    "recording": "Жазба",
    "ai": "AI",
    "you": "Сіз",
    "ai_ready": "Дайын",
    "camera_off": "Камера өшірулі",
    "stop_game": "Сессияны тоқтату",
    "start_game": "Сессияны бастау",
    "mic_permission": "Сессияны бастау үшін браузер баптауларынан микрофонға рұқсат беріңіз",
    "permissions_granted": "Рұқсаттар сәтті берілді!",
    "close": "Жабу",
    "microphone_required": "Please grant microphone permissions to start the session",
    "mic_required": "Сессияны бастау үшін микрофонды қосыңыз",
    "mic_not_detected": "Дыбыс әлі анықталмады — сөйлеп көріңіз немесе микрофонды тексеріңіз",
    "permissions_needed": "Микрофонға қол жеткізу міндетті. Камера — қалауыңызша",
    "agent": {
      "initializing": "Initializing...",
      "listening": "Listening",
      "thinking": "Thinking...",
      "speaking": "Speaking",
      "waiting": "Waiting for agent..."
    },
    "waiting_for_start": "Start the session to begin conversation",
    "grant_microphone": "Grant Microphone Access",
    "game_not_found": "Session Not Found",
    "game_not_found_desc": "Session with ID {id} could not be located.",
    "confirm": {
      "start_question": "Сенімдісіз бе? Сессияны тоқтата алмайсыз",
      "start_title": "Сессия басталды",
      "start_success": "Сессия сәтті басталды",
      "start_cancel_title": "Сессия басталмады",
      "start_cancel_msg": "Сессияның басталуы болдырылды",
      "end_question": "Сенімдісіз бе? Сессия аяқталады",
      "end_title": "Сессия аяқталды",
      "end_success": "Сессия сәтті аяқталды",
      "end_cancel_title": "Сессия аяқталмады",
      "end_cancel_msg": "Сессияның аяқталуы болдырылды"
    },
    "voice": {
      "disconnected": "Ажыратылды",
      "connecting": "Қосылу...",
      "connected": "Серверге қосылды",
      "connection_error": "Дауыс агентіне қосылу мүмкін болмады",
      "game_already_finished": "Бұл ойын аяқталған",
      "connection_timeout": "Connection to voice server timed out. This may be caused by a firewall or network restrictions. Check your network settings and try again.",
      "no_rooms_available": "Қазіргі уақытта бос бөлмелер жоқ. Кейінірек қайталап көріңіз.",
      "preparing_recording": "Жазба дайындалуда, {seconds} с-тан кейін қайталанады…",
      "recording_service_overloaded": "Жазба қызметі шамадан тыс жүктелген. Бірнеше минуттан кейін қайталап көріңіз.",
      "session_quota_exhausted": "Ұйымыңыздың сессиялар пакеті таусылды. Менеджеріңізге хабарласыңыз.",
      "connection_blocked": "Желіңіз AI-пен байланыс орнатуды бөгеді. Қажетті домендерге HTTPS (443) рұқсат беріп, қайта көріңіз.",
      "connection_blocked_signaling": "Желіңіздің файрволы немесе прокси-сервері дауыстық серверге қосылуды бөгейді. Басқа желіден немесе мобильді хотспот арқылы қосылып көріңіз.",
      "reconnecting": "Reconnecting...",
      "disconnect_dialog_title": "Connection Lost",
      "disconnect_dialog_message": "The connection was interrupted. Would you like to reconnect or finish the session?",
      "disconnect_retry": "Reconnect",
      "disconnect_finish": "Finish Session",
      "agent_join_timeout": "The AI agent did not connect in time. Please try again.",
      "stop_failed": "Failed to stop the session",
      "mic_enable_failed": "Microphone could not be enabled. You can try toggling it manually.",
      "mic_toggle_failed": "Failed to toggle microphone",
      "camera_toggle_failed": "Failed to toggle camera",
      "duplicate_tab_title": "Session Open in Another Tab",
      "duplicate_tab_message": "This session is already active in another browser tab. Close the other tab and reopen this page if you want to continue here.",
      "duplicate_tab_back": "Go Back",
      "duplicate_tab_disconnect_title": "Opened in Another Tab",
      "duplicate_tab_disconnect_message": "This tab was disconnected because the session is already active in another tab. Return to the session page from here."
    },
    "permissions_denied_safari": "Камера немесе микрофонға рұқсат берілмеді. Safari > Веб-сайттар > Камера/Микрофон бөлімінде рұқсат беріңіз.",
    "supported": "Браузер қолдайды"
  },
  "positions-page": {
    "title": "Атауы",
    "actions": " ",
    "add": "Лауазым қосу",
    "add_popup": "Лауазым қосу",
    "delete": "Лауазымды жою",
    "edit": "Лауазымды өзгерту",
    "edit_popup": "Лауазымды өзгерту"
  },
  "user-custom-fields-page": {
    "title": "Атауы",
    "type": "Түрі",
    "options_count": "Мәндер саны",
    "actions": " ",
    "add": "Өріс қосу",
    "add_popup": "Өріс қосу",
    "delete": "Өрісті жою",
    "delete_confirm": "Өрісті жою керек пе? Пайдаланушыларда сақталған мәндер бұдан былай көрсетілмейді.",
    "edit": "Өрісті өзгерту",
    "edit_popup": "Өрісті өзгерту",
    "empty": "Әлі теңшелетін өрістер жоқ",
    "error": "Өрісті сақтау мүмкін болмады",
    "type_text": "Мәтін",
    "type_select": "Анықтамалық",
    "type_locked_hint": "Өріс жасалғаннан кейін оның түрін өзгерту мүмкін емес",
    "options": "Мәндер",
    "options_hint": "Мұндағы мәндердің реті — ашылмалы тізімдегі рет",
    "options_required": "Кемінде бір мән қосыңыз",
    "option_title": "Мән",
    "option_add": "Мән қосу",
    "option_delete": "Мәнді жою",
    "option_delete_confirm": "Мәнді жою керек пе? Ол таңдалған пайдаланушыларда мән тазартылады.",
    "option_move_up": "Жоғары жылжыту",
    "option_move_down": "Төмен жылжыту"
  },
  "organizations-page": {
    "name": "Атауы",
    "host": "Хост",
    "duel_limit": "Сессия лимиті",
    "max_users": "Макс. пайдаланушылар",
    "max_users_hint": "0 = шексіз",
    "max_vs_ai_games_per_scenario": "Бір сценарий бойынша ойыншыға арналған AI-ойындардың максималды саны",
    "max_vs_ai_games_per_scenario_hint": "Бос — шексіз. Ойыншының өз бетінше ойын құруына қолданылады",
    "employee_report_daily_limit": "Қызметкер есептерінің тәуліктік лимиті",
    "employee_report_daily_limit_hint": "Бос — платформаның жалпы лимиті. Әкімшілер мен басшыларға қолданылады",
    "employee_report_hourly_limit": "Қызметкер есептерінің сағаттық лимиті",
    "employee_report_hourly_limit_hint": "Бос — платформаның жалпы лимиті. Әкімшілер мен басшыларға қолданылады",
    "registration": "Тіркеу ашық",
    "timezone": "Аймақ",
    "locale": "Тіл",
    "users_count": "Пайдаланушылар",
    "actions": " ",
    "add": "Ұйым қосу",
    "add_popup": "Ұйым қосу",
    "delete": "Ұйымды жою",
    "edit": "Ұйымды өзгерту",
    "edit_popup": "Ұйымды өзгерту",
    "available_languages": "Қолжетімді тілдер",
    "show_game_numbers_for_player": "Сессия нөмірлерін қатысушыларға көрсету",
    "allow_players_choose_expert": "Қатысушыларға сарапшы таңдауға рұқсат ету",
    "send_message": "Менеджерлерге хабарлама жіберу",
    "message": "Хабарлама",
    "send": "Жіберу",
    "clear_message": "Хабарламаны тазалау",
    "current_message": "Ағымдағы хабарлама",
    "two_factor_method": "Екі факторлы аутентификация",
    "two_factor_disabled": "Өшірілген",
    "two_factor_email": "Email",
    "two_factor_sms": "SMS",
    "hidden_menu_items": "Hidden menu items",
    "hide_ai_results": "AI нәтижелерін жасыру",
    "hide_player_rating": "Компания рейтингін қатысушылардан жасыру",
    "show_character_memory_to_player": "Персонаж жадын ойыншыға көрсету",
    "show_meeting_recap_to_player": "Кездесу қорытындысын ойыншыға көрсету",
    "create_user_on_external_launch": "Сыртқы жүйеден алғашқы сұраныс келгенде пайдаланушы жасау",
    "create_user_on_external_launch_hint": "Өшірулі болса, сыртқы жүйеден алғаш рет сұраныс келген пайдаланушыға сессияның орнына бас тарту қайтарылады. Осылай жасалған әрбір пайдаланушы жазылымда орын алады.",
    "allow_external_email_linking": "Сыртқы пайдаланушыны Email бойынша байланыстыруға рұқсат ету",
    "allow_external_email_linking_hint": "Қосулы болса, сыртқы жүйе Email мекенжайын өз серверінен хабарлаған жағдайда, сыртқы адам бар пайдаланушымен байланыстырылады. Өшірулі болса, мұндай сұраныс қабылданбайды және сол мекенжаймен екінші пайдаланушы жасалмайды."
  },
  "users-page": {
    "import": "Импорт",
    "user": "Қатысушы",
    "roles": "Рөлдер",
    "effectiveness": "Тиімділік",
    "department": "Бөлім",
    "position": "Лауазым",
    "status": "Мәртебе",
    "actions": " ",
    "add": "Пайдаланушы қосу",
    "add_popup": "Пайдаланушы қосу",
    "last_login_at": "Соңғы онлайн",
    "delete": "Жою",
    "view": "Қарау",
    "login": "Кіру",
    "message": "Хабарлама",
    "activate": "Бұғаттан шығару",
    "deactivate": "Бұғаттау",
    "edit_popup": "Пайдаланушыны өңдеу",
    "total_in_org": "Ұйымдағы барлығы",
    "multi_role_note": "Бірнеше рөлі бар қатысушы әр белгішеде есептеледі",
    "filter_role": "Рөл",
    "all_roles": "Барлық рөлдер",
    "filter_activity": "Аяқталған сценарийлер",
    "activity_played": "Иә",
    "activity_not_played": "Жоқ",
    "filter_activity_from": "Аяқталған күннен бастап",
    "filter_last_login_from": "Кіру күні",
    "filter_custom_field": "Теңшелетін өріс",
    "filter_custom_field_value": "«{field}» мәні",
    "last_login_never": "Кірмеген",
    "last_login_since": "Кірген күні",
    "cases_progress": "Аяқталған кейстер",
    "cases_progress_value": "{completed} / {assigned}",
    "export": "Экспорт",
    "popup": {
      "name": "Аты",
      "last_name": "Тегі",
      "patronymic": "Әкесінің аты",
      "phone": "Телефон",
      "timezone": "Уақыт белдеуі",
      "language": "Тіл",
      "country": "Ел",
      "invalid_phone": "Нөмір форматы дұрыс емес",
      "department": "Бөлім",
      "position": "Лауазым",
      "effectiveness": "Тиімділік",
      "roles": "Рөлдер",
      "organizations": "Компаниялар",
      "blocked": "Бұғатталған",
      "is_active": "Белсенді",
      "email_verified": "Email расталған",
      "email_not_verified": "Email расталмаған",
      "subordinates": "Бағыныштылар",
      "search_subordinates": "Қатысушыларды іздеу...",
      "import": {
        "download_example": "Үлгіні жүктеу",
        "title": "Пайдаланушыларды импорттау",
        "button": "Жүктеу",
        "label": "Excel файлы",
        "marker_hint": "Бұрыннан бар пайдаланушы үшін бос ұяшық ағымдағы мәнді сақтайды, ал сызықша (-) өрісті тазартады.",
        "result_title": "Импорт басталды",
        "result_created": "Құрылатын саны: {count}",
        "result_updated": "Жаңартылатын саны: {count}",
        "result_skipped": "Өткізіп жіберілген саны: {count}",
        "result_skipped_row": "{row}-жол, {email}: {reason}",
        "result_truncated": "…тағы өткізіп жіберілген жол саны: {count}"
      }
    }
  },
  "users-ranking-page": {
    "user": "Қатысушы",
    "roles": "Рөлдер",
    "effectiveness": "Тиімділік",
    "average-effectiveness": "Бір сессияға орташа",
    "sessions-count": "Сессиялар",
    "department": "Бөлім",
    "position": "Лауазым",
    "status": "Мәртебе",
    "export": "Экспорт",
    "actions": " "
  },
  "user-detail": {
    "games_finished": "Аяқталған сессиялар",
    "not_found": "Пайдаланушы табылмады",
    "games_total": "Барлығы сессия",
    "username": "Қатысушы",
    "phone": "Телефон",
    "status": "Мәртебе",
    "language": "Тіл",
    "timezone": "Уақыт белдеуі",
    "edit": "Өңдеу",
    "department": "Департамент",
    "position": "Лауазым",
    "activate": "Белсендіру",
    "block": "Бұғаттау",
    "account": {
      "title": "Аккаунт",
      "summary": {
        "title": "Жалпы ақпарат",
        "games": "Барлығы сессия",
        "place": "Рейтингтегі орын",
        "effectiveness": "Тиімділік",
        "time": "Сессиядағы уақыт"
      }
    },
    "security": {
      "title": "Қауіпсіздік",
      "change_password_title": "Құпиясөзді өзгерту",
      "change_password": "Құпиясөзді өзгерту",
      "new_password": "Жаңа құпиясөз",
      "confirm_new_password": "Құпиясөзді растаңыз",
      "password_requirements": "Құпиясөз талаптары:",
      "password_requirements_1": "Ең азы 8 таңба",
      "password_requirements_2": "Кемінде бір кіші әріп",
      "password_requirements_3": "Кемінде бір сан немесе символ"
    },
    "statistics": {
      "title": "Статистика"
    }
  },
  "game": {
    "character_memory": {
      "title": "Персонаж не есте сақтайды",
      "subtitle": "Персонаждың осы ойынға әкелген өткен кездесулер туралы жады",
      "preview_subtitle": "Жад әлі жазылмаған — персонаж оны ойын басталған сәтте алады",
      "unavailable": "Алдыңғы кездесу персонажға қолжетімсіз: ол оны есіне алмай әңгімені бастайды.",
      "agreements": "Келісімдер",
      "player_commitments": "Ойыншының уәделері",
      "character_commitments": "Персонаждың уәделері",
      "open_issues": "Ашық мәселелер",
      "facts": "Аталған деректер",
      "attitude": "Ойыншыға көзқарасы",
      "evaluation_passed": "Сол кездесудің бағалау нәтижелері персонажға берілді",
      "evaluation_not_ready": "Сол кездесудің бағалауы әлі дайын емес — есептелген соң персонаж оны алады.",
      "evaluation_hidden": "Бағалау мәтіндері ұйым параметрлерімен жасырылған.",
      "overall_effectiveness": "Жалпы тиімділік",
      "outcome": {
        "deal": "Мәміле",
        "partial": "Ішінара",
        "no_deal": "Мәміле жоқ",
        "unclear": "Нәтиже белгісіз"
      }
    },
    "meeting_recap": {
      "title": "Кездесу қорытындысы",
      "outcome": "Кездесудің нәтижесі",
      "agreements": "Келісімдер",
      "player_commitments": "Ойыншының уәделері",
      "character_commitments": "Персонаждың уәделері",
      "open_issues": "Ашық мәселелер",
      "facts": "Аталған деректер",
      "pending": "Кездесу қорытындысы әлі дайындалып жатыр. Кейінірек қайталап көріңіз.",
      "unavailable": "Бұл кездесудің қорытындысын құру мүмкін болмады.",
      "none": "Бұл ойын бойынша қорытынды жоқ."
    },
    "title": "Сессия",
    "team": "Команда",
    "expert": "Сарапшы",
    "points": "ұпай",
    "your_result": "Сіздің нәтижеңіз",
    "joined_at": "Басталуы:",
    "ended_at": "Аяқталу күні",
    "min": "мин.",
    "duration": "Ұзақтығы",
    "from_average": "орташадан",
    "ai_expert": "AI сарапшысы",
    "ai_evaluation_in_progress": "AI-бағалау жүріп жатыр",
    "delete_ai_request": "AI бағасын жою",
    "ai_expert_refresh": "AI нәтижелерін жаңарту",
    "ai_expert_refresh_rejected": {
      "evaluation_not_completed": "Қазір AI нәтижелерін жаңарту мүмкін емес: AI-бағалау әлі жүріп жатыр.",
      "answer_pending": "Қазір AI нәтижелерін жаңарту мүмкін емес: AI жауабы әлі келген жоқ.",
      "recognition_pending": "Қазір AI нәтижелерін жаңарту мүмкін емес: жазба әлі танылып жатыр.",
      "recognition_has_no_speech": "Жазбада сөз танылмады, сондықтан AI нәтижелерін жаңарту мүмкін емес.",
      "recognition_has_too_little_speech": "Жазбада қатысушылардың сөйлесуі дерлік жоқ, сондықтан AI-бағалау орындалмады.",
      "no_ai_evaluation": "Бұл сессияда AI-бағалау енді жоқ.",
      "game_evaluation_blocked": "Сессия өткізілмеді немесе болдырылмады, сондықтан AI-бағалау қолжетімсіз."
    },
    "ai_expert_unavailable": {
      "recognition_has_no_speech": "Жазбада сөз танылмады, сондықтан AI-бағалау орындалмады.",
      "recognition_has_too_little_speech": "Жазбада қатысушылардың сөйлесуі дерлік жоқ, сондықтан AI-бағалау орындалмады.",
      "game_evaluation_blocked": "Сессия өткізілмеді немесе болдырылмады, сондықтан AI-бағалау қолжетімсіз."
    },
    "ai_expert_refresh_failed": "AI нәтижелерін жаңарту мүмкін болмады.",
    "speaker_mapping": {
      "title": "Қатысушылар мен дауыстар",
      "voice": "Дауыс {number}",
      "unknown": "Анықталмады",
      "needs_review": "Қатысушыларды тексеріңіз",
      "needs_review_hint": "Қатысушылар дұрыс анықталмаған болуы мүмкін: AI-бағалаудың керекті адамдарға жеткенін тексеріңіз.",
      "failed": "Қатысушыларды автоматты түрде анықтау мүмкін болмады.",
      "unavailable": "AI провайдері қолжетімсіз болды: қатысушылар келесі бағалауда анықталады.",
      "empty": "Стенограммада қатысушыларды анықтауға болатын сөз жоқ.",
      "corrected_manually": "Қолмен түзетілді",
      "under_reevaluation": "AI-бағалау осы қатысушылармен жүріп жатыр. Ол аяқталғанша, бетте бұрынғы нәтижелер көрсетіледі.",
      "confirm": "Қатысушылар дұрыс",
      "review": "Тексеру",
      "dialog_hint": "Әр дауысқа қатысушы тағайындаңыз. Сақтағаннан кейін AI-бағалау қайта сұралады.",
      "save": "Сақтау",
      "cancel": "Бас тарту",
      "confirmed": "Қатысушылар расталды",
      "fixed": "Қатысушылар түзетілді, AI-бағалау қайта сұралды",
      "action_failed": "Әрекетті орындау мүмкін болмады"
    },
    "ai_expert_created": "Сессияны бағалау процесі іске қосылды. Бұл бірнеше минут алуы мүмкін. Нәтиже дайын болғанда хабарлама жібереміз.",
    "expert_already_requested": "Бағалау басқа қатысушы тарапынан сұралған",
    "request_expert": "Сарапшы сұрау",
    "assign_expert": "Сарапшы тағайындау",
    "ai_process": "Күтіңіз, өңделуде",
    "analyzing_results": "Сессия нәтижелері талдануда...",
    "complete_expert_request": "Бағалауды аяқтау",
    "tabs": {
      "description": {
        "title": "Сценарий сипаттамасы",
        "subtitle": "Сессия ақпараты мен ережелері",
        "situation": "Жағдай",
        "your_role": "Сіздің рөліңіз",
        "player_role": "Ойыншының рөлі: {name}",
        "team_tab": "{team} командасы",
        "empty": "Бұл сессияда сипаттамалар жоқ.",
        "load_error": "Сипаттаманы жүктеу мүмкін болмады. Кейінірек қайталап көріңіз."
      },
      "results": {
        "title": "Нәтижелер",
        "effectiveness_summary": "Команда тиімділігі",
        "your_effectiveness": "Сіздің тиімділігіңіз",
        "parameters_section": "Параметрлер",
        "parameter": "Параметр",
        "target": "Шекті мән",
        "coefficient": "Коэффициент",
        "value": "Келісім",
        "points": "Ұпай",
        "points_short": "ұпай",
        "combinations": "Комбинациялар",
        "combination_bonus": "Комбинация бонусы",
        "questions": "Сұрақтар",
        "question": "Сұрақ",
        "answer": "Жауап",
        "total": "Барлығы"
      },
      "comments": {
        "title": "Бейне-талдау",
        "comments": "Пікірлер",
        "no_comments": "Әзірге пікір жоқ",
        "no_video": "Бейне қолжетімсіз",
        "video_processing": "Бейне өңделуде...",
        "count": "пікір",
        "delete": "Жою",
        "edit": "Өзгерту",
        "popup": {
          "add": "Пікір қосу",
          "edit": "Пікірді өзгерту",
          "comment": "Пікір",
          "player": "Қатысушы",
          "all": "Барлығына"
        }
      },
      "feedback": {
        "title": "Сессия бағасы",
        "no_feedback": "Әзірге баға жоқ",
        "no_feedback_description": "Бұл сессия үшін кері байланыс әлі қосылмаған",
        "overall_score": "Жалпы баға",
        "skills_evaluated": "{count} дағды бағаланды",
        "no_comment": "Пікір көрсетілмеген",
        "score_button": "Қатысушыны бағалау",
        "player": "Қатысушы",
        "author": "Автор",
        "download": "Бейнені жүктеу",
        "download_transcript": "Стенограмманы жүктеу",
        "evaluators": {
          "ai": "Сарапшы",
          "expert": "Сарапшы",
          "player": "Қатысушы",
          "manager": "Басшы",
          "head": "Басшы"
        },
        "popup": {
          "score": {
            "title": "Қатысушы бағасы",
            "comment": "Пікір",
            "error": "Қатысушының барлық дағдыларын бағалау қажет",
            "save_error": "Бағаны сақтау мүмкін болмады. Сізде осы қатысушыны бағалауға рұқсат жоқ болуы мүмкін."
          }
        }
      },
      "checklist": {
        "title": "Чек-лист",
        "total": "Өткен тармақтар",
        "pass": "Орындалды",
        "fail": "Орындалмады",
        "cannot_assess": "Бағалау мүмкін емес",
        "comment": "Жалпы пікір",
        "category": "Санат",
        "author": "Бағалаушы",
        "player": "Қатысушы",
        "passed_of": "{total} ішінен {passed}",
        "evidence": "Дәлел",
        "rationale": "Негіздеме",
        "no_results": "Чек-лист бойынша бағалау әлі дайын емес",
        "no_results_description": "Бұл сессия чек-лист бойынша әлі бағаланған жоқ"
      }
    }
  },
  "scenario": {
    "steps": {
      "information": {
        "create_new_ai_profile": "Жаңасын құру",
        "edit_ai_profile": "Өңдеу",
        "delete_ai_profile": "Жою",
        "confirm_delete_ai_profile": "Бұл AI профильді жойғыңыз келе ме?",
        "first_header": "Негізгі баптаулар",
        "second_header": "AI қатысушысы",
        "third_header": "Сценарий сипаттамасы",
        "next_scenario_label": "Келесі сценарий",
        "next_scenario_placeholder": "Таңдалмаған",
        "next_scenario_hint": "Осы сценарий аяқталғаннан кейін келесі сценарий бойынша сессия автоматты құрылады.",
        "memory_header": "Келесі кездесумен байланыс",
        "memory_group_evaluation": "Келесі кездесудің бағалауы",
        "memory_group_character": "Келесі кездесудің персонажы",
        "memory_pass_to_next": "осы кездесуді есінде сақтайды",
        "memory_pass_to_next_hint": "Келесі сценарийдің персонажы әңгімені таныс адаммен сөйлескендей бастайды: ол осы кездесудің қысқаша қорытындысын, келісімдерді, тараптардың уәделерін, ашық мәселелер мен аталған деректерді алады. Әңгіме жазбасы мен сөзбе-сөз дәйексөздер оған берілмейді. Келесі кездесу осының жалғасы болса, мұны қосыңыз: келіссөздердің екінші раунды, тұрақты өтетін жеке кездесу.",
        "memory_pass_evaluation_to_next": "осы кездесудің бағалау нәтижелерін біледі",
        "memory_pass_evaluation_to_next_hint": "Жадымен бірге персонаж дағдылар бойынша кері байланыс мәтіндерін және осы кездесудің жалпы қорытындысын алады, осылайша ойыншыда не сәтті шыққанын есте сақтайтын коуч сияқты әрекет ете алады.",
        "memory_evaluate_next_with_agreements": "осы кездесудің келісімдерін ескереді",
        "memory_evaluate_next_with_agreements_hint": "Келесі кездесуді бағалау кезінде AI-сарапшы осы кездесудің келісімдерін, тараптардың уәделерін және ашық мәселелерін көреді, осылайша ойыншы уәдесін орындағанын тексере алады. Алдыңғы бағалаудың балдары мен мәтіндері сарапшыға берілмейді — бұл жаңа бағалауға әсер етпеу үшін.",
        "is_public": "Ашық",
        "is_public_hint": "Қосулы болса — сценарий қатысушыларға таңдауға қолжетімді.",
        "title": "Сценарий",
        "subtitle": "Негізгі ақпарат",
        "image": "сценарий суреті",
        "field_title": "Атауы",
        "competence": "Құзырет",
        "description": "Сипаттама",
        "description_a": "A командасына сипаттама",
        "description_b": "B командасына сипаттама",
        "ai_profile": "AI профиль",
        "ai_profile_placeholder": "Тек AI-ға қарсы сессиялар үшін",
        "ai_description": "AI үшін сипаттама",
        "optimize_ai_description": "Optimize with AI",
        "optimizing_in_progress": "AI is optimizing the description. Please wait...",
        "optimize_error": "Failed to optimize the description. Please try again.",
        "ai_description_hint": "Тиімді AI промпт жазу тәжірибені қажет етеді. Нашар жазылған промпт сценарийдің болжанбаған әрекетіне әкелуі мүмкін. Сенімді болмасаңыз, «ИИ көмегімен оңтайландыру» батырмасын пайдаланыңыз, сценарий генерациясын қолданып көріңіз немесе менеджеріңізге хабарласыңыз.",
        "knowledge_base_header": "Білім қоры",
        "knowledge_base_documents": "Білім қоры құжаттары",
        "knowledge_base_documents_hint": "AI ойыншысына контекст беру үшін құжаттарды тіркеңіз",
        "knowledge_base_no_documents": "Қолжетімді құжаттар жоқ. Құжаттарды \"Білім қоры\" бетінде жүктеңіз.",
        "knowledge_base_chunks": "{count} үзінді",
        "knowledge_base_purpose_voice": "AI сессиясы",
        "knowledge_base_purpose_eval": "Бағалау"
      },
      "settings": {
        "title": "Баптаулар",
        "subtitle": "Сценарий баптаулары",
        "min_players": "Мин. қатысушы",
        "min_players_hint": "2-ден 20-ға дейін сан",
        "max_players": "Макс. қатысушы",
        "max_players_hint": "2-ден 20-ға дейін сан",
        "protocol_time": "Протокол толтыру уақыты (мин)",
        "protocol_time_hint": "1-ден 1440-қа дейін сан",
        "preparation_time": "Дайындық уақыты (мин)",
        "preparation_time_hint": "0-ден 1440-қа дейін сан. 0 — сипаттама бірден көрінеді",
        "game_duration": "Сессия ұзақтығы (мин)",
        "game_duration_hint": "1-ден 60-қа дейін сан",
        "is_team": "Командаларға",
        "is_camera_required": "Камера міндетті",
        "is_self_rated": "Өзін-өзі бағалау мүмкін",
        "is_each_other_rated": "Бір-бірін бағалау мүмкін",
        "is_expert_rated": "Сарапшы бағалай алады",
        "is_ai_rated": "AI бағалай алады",
        "show_results": "Нәтижелерді көрсету",
        "automatically": "автоматты түрде",
        "manually": "қолмен"
      },
      "parameters": {
        "title": "Параметрлер",
        "subtitle": "Қатысушыларға арналған параметрлер",
        "field_title": "Атауы",
        "team_a": "A командасы",
        "team_b": "B командасы",
        "player_a": "A қатысушысы",
        "player_b": "B қатысушысы",
        "points": "Мәні",
        "ratio": "Коэффициент",
        "add": "Параметр қосу"
      },
      "questions": {
        "title": "Сұрақтар",
        "subtitle": "Қатысушыларға сұрақтар",
        "question": "Сұрақ",
        "team": "Команда",
        "team_placeholder": "Команданы таңдаңыз",
        "answers": "Жауаптар",
        "points": "Ұпай",
        "select_answers": "Жауаптарды таңдаңыз",
        "add_combination": "Комбинация қосу",
        "add_question": "Сұрақ қосу"
      },
      "next": "Алға",
      "previous": "Артқа",
      "save": "Сақтау"
    },
    "saved": "Сценарий сақталды",
    "to_list": "Тізімге қайту",
    "add_detail": "Сценарий қосу",
    "edit_detail": "Сценарийді өңдеу"
  },
  "notifications": {
    "title": "Хабарландырулар",
    "mark_unread": "Барлығын оқылмаған деп белгілеу",
    "mark_read": "Барлығын оқылған деп белгілеу",
    "delete_all": "Барлық хабарландыруды жою",
    "no_new": "Жаңа хабарландыру жоқ",
    "system": "Жүйе",
    "evaluation": {
      "ready": {
        "subject": "Сессия бағасы #:gameNumber",
        "text": "Сарапшы сессияны бағалады"
      }
    },
    "game": {
      "created": {
        "game_assigned": "Сізге сессия тағайындалды",
        "role": "Рөл:"
      },
      "proposal": {
        "subject": "Сессия уақытын келісу",
        "time": "Уақыты:",
        "description": "Растаңыз немесе өз нұсқаңызды ұсыныңыз"
      },
      "agreed": {
        "subject": "Сессия уақыты келісілді",
        "time": "Уақыты:",
        "description": "Сипаттама және дайындық мүмкіндігі басталуына :preparationTime минут қалғанда ашылады",
        "description_zero": "Сіз сценарий сипаттамасымен қазірден танысып, дайындала аласыз"
      },
      "preparation": {
        "subject": "Сессияға дайындық",
        "text": "Сессияға дайындық ашылды."
      },
      "started": {
        "subject": "Сессия #:gameNumber басталды",
        "text": "Қосылыңыз!"
      },
      "missed": {
        "subject": "Сессия #:gameNumber өткізіліп алынды",
        "text": "Сіз сессияны өткізіп алдыңыз"
      },
      "completed": {
        "subject": "Сессия #:gameNumber аяқталды",
        "text": "Сәтті сессия"
      },
      "failed": {
        "subject": "Сессия #:gameNumber сәтсіз аяқталды",
        "text": "Сәтсіз аяқталды"
      },
      "results": {
        "proposed": {
          "subject": "Сессия протоколын келісу #:gameNumber",
          "text": "Келісу қолжетімді"
        },
        "declined": {
          "subject": "Сессия протоколы #:gameNumber қабылданбады",
          "text": "Ұсыныс қабылданбады"
        },
        "not_agreed": {
          "subject": "Сессия #:gameNumber: тараптар келіспеді",
          "text": "Қарсылас капитан тараптар келіспеді деп белгіледі. Сессия сәтсіз аяқталды, нәтижелер есепке алынбады."
        }
      },
      "meeting": {
        "ended-player": {
          "subject": "Сессия бойынша кездесу #:gameNumber аяқталды",
          "text": "Нәтижелерді күтіңіз"
        },
        "ended-captain": {
          "subject": "Сессия бойынша кездесу #:gameNumber аяқталды",
          "text_fill": "Протоколды толтырыңыз",
          "text_wait": "Протокол толтырылуын күтіңіз",
          "protocol_time": "Протокол уақыты(мин): :protocolTime"
        }
      }
    }
  },
  "profile": {
    "avatar_allowed": "JPG, GIF немесе PNG. Ең көп өлшем: 2MB",
    "avatar_label_choose": "Таңдаңыз",
    "avatar_label_your_avatar": "аватарыңызды",
    "name": "Аты",
    "last_name": "Тегі",
    "patronymic": "Әкесінің аты",
    "phone": "Телефон",
    "timezone": "Уақыт белдеуі",
    "language": "Тіл",
    "country": "Ел",
    "invalid_phone": "Нөмір форматы дұрыс емес",
    "save_changes": "Сақтау",
    "account": "Профиль",
    "security": "Қауіпсіздік",
    "statistics": "Статистика",
    "notifications": "Хабарландырулар",
    "change_password_title": "Құпиясөзді өзгерту",
    "change_password": "Құпиясөзді өзгерту",
    "current_password": "Ағымдағы құпиясөз",
    "new_password": "Жаңа құпиясөз",
    "confirm_new_password": "Құпиясөзді растаңыз",
    "password_requirements": "Құпиясөз талаптары:",
    "password_requirements_1": "Ең азы 8 таңба",
    "password_requirements_2": "Кемінде бір кіші әріп",
    "password_requirements_3": "Кемінде бір сан немесе символ",
    "two_factor_title": "Екі факторлы аутентификация",
    "two_factor_description": "Аккаунтыңызға қосымша қорғаныс деңгейін қосыңыз",
    "two_factor_org_enforced": "Екі факторлы аутентификация сіздің ұйымыңызда міндетті",
    "two_factor_method": "Аутентификация әдісі",
    "two_factor_disabled": "Өшірілген",
    "two_factor_email": "Email",
    "two_factor_sms": "SMS",
    "two_factor_save": "2FA параметрлерін сақтау"
  },
  "auth": {
    "password": "Құпиясөз",
    "new_password": "Жаңа құпиясөз",
    "remember": "Мені есте сақтау",
    "timezone": "Уақыт белдеуі",
    "forgot": "Құпиясөзді ұмыттыңыз ба?",
    "login": "Кіру",
    "login_title": "Кіру",
    "new_password_title": "Құпиясөзді өзгерту",
    "change_password": "Сақтау",
    "country": "Ел",
    "invalid_phone": "Нөмір форматы дұрыс емес",
    "privacy_policy_title": "Платформа ережелері",
    "privacy_policy_text": "Платформа ережелерінің мәтіні...",
    "first_time": "Құпиясөзді ұмытпадыңыз ба?",
    "registration": "Аккаунт ашу",
    "forgot_title": "Құпиясөзді ұмыттыңыз ба?",
    "forgot_description": "Email енгізіңіз, біз сізге құпиясөзді қалпына келтіру нұсқаулығын жібереміз",
    "send_reset_link": "Сілтемені жіберу",
    "back_to_login": "Артқа",
    "register": "Аккаунт ашу",
    "name": "Аты",
    "last_name": "Тегі",
    "patronymic": "Әкесінің аты",
    "phone": "Телефон",
    "enter_password": "Құпиясөз енгізіңіз",
    "confirm_password": "Құпиясөзді растаңыз",
    "not_first_time": "Аккаунтыңыз бар ма?",
    "agree_too": "Мен келісемін",
    "privacy_policy": "платформа ережелерімен",
    "accept": " Мен келісемін ",
    "password_validation": "Құпиясөз бас/кіші әріптерден, сандардан, арнайы символдардан тұрып, 8 таңбадан ұзын болуы керек",
    "password_confirm_error": "Құпиясөздер сәйкес емес",
    "set_password": "Құпиясөзді сақтау",
    "reset_password": "Құпиясөзді қалпына келтіру",
    "for": "үшін",
    "sign_in_to_for": "{org} үшін {app} жүйесіне кіру",
    "registration_title": "Аккаунт ашу",
    "verify_title": "Email растау",
    "verify_head": "Email-ды растаңыз",
    "verify_description": "Біз сізге белсендіру сілтемесін жібердік.",
    "verify_new_link": "Белсендіру сілтемесі қайта жіберілді.",
    "verify_send": "Қайта жіберу",
    "verify_spam": "Сұрау тым көп. Бір минуттан кейін қайталаңыз",
    "verify_logout": "Шығу",
    "two_factor_title": "Екі факторлы аутентификация",
    "two_factor_description_email": "Біз растау кодын электрондық поштаңызға жібердік. Төменде кодты енгізіңіз.",
    "two_factor_description_sms": "Біз растау кодын телефон нөміріңізге жібердік. Төменде кодты енгізіңіз.",
    "two_factor_code_label": "Растау коды",
    "two_factor_code_placeholder": "6 санды код енгізіңіз",
    "two_factor_verify": "Растау",
    "two_factor_resend": "Кодты қайта жіберу",
    "two_factor_resend_success": "Жаңа код жіберілді",
    "two_factor_back": "Кіруге оралу"
  },
  "filepond": {
    "upload": "Жүктеңіз",
    "upload_complete": "Жүктелді",
    "uploading": "Жүктеу",
    "loading": "Жүктелуде",
    "tap_to_cancel": "болдырмау үшін басыңыз",
    "tap_to_undo": "болдырмау үшін басыңыз",
    "upload_aborted": "Жүктеу болдырылды",
    "file_too_large": "Файл тым үлкен"
  },
  "text-editor": {
    "image": "Суретіңізді редакторға сүйреп әкеліңіз"
  },
  "webrtc": {
    "ready_to_start": "Басталуды күту",
    "connected": "Қосылды",
    "connection_lost": "Байланыс үзілді. Қайта көріңіз."
  },
  "device_settings": {
    "title": "Аудио және видео құрылғылар баптауы",
    "speaker": "Динамик/Аудио шығу",
    "refresh_devices": "Құрылғыларды жаңарту",
    "speaker_switch_unsupported": "Осы браузерде динамикті ауыстыру қолдау көрсетілмейді"
  },
  "device_setup": {
    "mic_level": "Микрофон деңгейі",
    "mic_on": "Қос",
    "mic_off": "Өш",
    "cam_on": "Қос",
    "cam_off": "Өш"
  },
  "device_test": {
    "title": "Аудио құрылғыларды тексеру",
    "speaker_test": "Динамикті тексеру",
    "speaker_hint": "Таңдалған динамик арқылы тест дыбысын ойнату үшін түймені басыңыз",
    "play_sound": "Тест дыбысын ойнату",
    "playing": "Ойнатылуда...",
    "speaker_success": "Дыбыс ойнатылды ✓",
    "mic_test": "Микрофонды тексеру",
    "mic_hint": "Түймені басып, микрофонға сөйлеңіз, оның жұмыс істейтінін тексеру үшін",
    "volume_level": "Дыбыс деңгейі",
    "speak_now": "Қазір сөйлеңіз...",
    "seconds_short": "с",
    "start_mic_test": "Микрофонды тексеру",
    "testing": "Тексерілуде...",
    "test_again": "Қайта тексеру",
    "mic_success": "Микрофон дұрыс жұмыс істейді!",
    "mic_fail": "Микрофон мәселесі анықталды",
    "mic_fail_hint": "Дыбыс анықталмады. Микрофонның қосылғанын, өшірілмегенін және параметрлерде дұрыс таңдалғанын тексеріңіз."
  },
  "ai_assistant_types": {
    "type": "Түрі",
    "negotiation": "Келіссөз",
    "feedback": "Кері байланыс",
    "ai_profile": "AI-мен сессия"
  },
  "Login": "Кіру",
  "UI Elements": "UI Elements",
  "Forms & Tables": "Forms & Tables",
  "Welcome": "Welcome",
  "Pages": "Pages",
  "Charts & Maps": "Charts & Maps",
  "Others": "Others",
  "Typography": "Typography",
  "Cards": "Cards",
  "Basic": "Basic",
  "Advance": "Advance",
  "Widgets": "Widgets",
  "Components": "Components",
  "Alert": "Alert",
  "Close Alert": "Close Alert",
  "Avatar": "Avatar",
  "Badge": "Badge",
  "Button": "Button",
  "Calendar": "Calendar",
  "Image": "Image",
  "Pagination": "Pagination",
  "Progress Circular": "Progress Circular",
  "Progress Linear": "Progress Linear",
  "Autocomplete": "Autocomplete",
  "Tooltip": "Tooltip",
  "Slider": "Slider",
  "Date Time Picker": "Date Time Picker",
  "Select": "Select",
  "Switch": "Switch",
  "Checkbox": "Checkbox",
  "Radio": "Radio",
  "Textarea": "Textarea",
  "Rating": "Rating",
  "File Input": "File Input",
  "Otp Input": "Otp Input",
  "Form Layout": "Form Layout",
  "Form Validation": "Form Validation",
  "Charts": "Charts",
  "Apex Chart": "Apex Chart",
  "Chartjs": "Chartjs",
  "Account Settings": "Account Settings",
  "User Profile": "User Profile",
  "FAQ": "FAQ",
  "Dialog Examples": "Dialog Examples",
  "Pricing": "Pricing",
  "List": "List",
  "Edit": "Edit",
  "Nav Levels": "Nav Levels",
  "Level 2.1": "Level 2.1",
  "Level 2.2": "Level 2.2",
  "Level 3.1": "Level 3.1",
  "Level 3.2": "Level 3.2",
  "Raise Support": "Raise Support",
  "Documentation": "Documentation",
  "Dashboards": "Dashboards",
  "Analytics": "Analytics",
  "Apps & Pages": "Apps & Pages",
  "Email": "Email",
  "Chat": "Chat",
  "Invoice": "Invoice",
  "Preview": "Preview",
  "Add": "Add",
  "User": "User",
  "View": "View",
  "Login v1": "Login v1",
  "Login v2": "Login v2",
  "Register v1": "Register v1",
  "Register v2": "Register v2",
  "Register": "Тіркеу",
  "Forget Password v1": "Forget Password v1",
  "Forget Password v2": "Forget Password v2",
  "Forgot Password v1": "Forgot Password v1",
  "Forgot Password v2": "Forgot Password v2",
  "Forgot Password": "Forgot Password",
  "Reset Password v1": "Reset Password v1",
  "Reset Password v2": "Reset Password v2",
  "Reset Password": "Reset Password",
  "Miscellaneous": "Miscellaneous",
  "Coming Soon": "Coming Soon",
  "Not Authorized": "Not Authorized",
  "Under Maintenance": "Under Maintenance",
  "Error": "Error",
  "Statistics": "Statistics",
  "Actions": "Actions",
  "Access Control": "Access Control",
  "User Interface": "User Interface",
  "CRM": "CRM",
  "eCommerce": "eCommerce",
  "Icons": "Icons",
  "Chip": "Chip",
  "Dialog": "Dialog",
  "Expansion Panel": "Expansion Panel",
  "Combobox": "Combobox",
  "Textfield": "Textfield",
  "Range Slider": "Range Slider",
  "Menu": "Menu",
  "Snackbar": "Snackbar",
  "Tabs": "Tabs",
  "Form Elements": "Form Elements",
  "Form Layouts": "Form Layouts",
  "Authentication": "Authentication",
  "Page Not Found - 404": "Page Not Found - 404",
  "Not Authorized - 401": "Not Authorized - 401",
  "Server Error - 500": "Server Error - 500",
  "2": "2",
  "Forms": "Forms",
  "Timeline": "Timeline",
  "Disabled Menu": "Disabled Menu",
  "Help Center": "Help Center",
  "Verify Email": "Verify Email",
  "Verify Email v1": "Verify Email v1",
  "Verify Email v2": "Verify Email v2",
  "Two Steps": "Two Steps",
  "Two Steps v1": "Two Steps v1",
  "Two Steps v2": "Two Steps v2",
  "Custom Input": "Custom Input",
  "Extensions": "Extensions",
  "Tour": "Tour",
  "Register Multi-Steps": "Register Multi-Steps",
  "Wizard Examples": "Wizard Examples",
  "Checkout": "Checkout",
  "Create Deal": "Create Deal",
  "Property Listing": "Property Listing",
  "Roles & Permissions": "Roles & Permissions",
  "Roles": "Roles",
  "Simple Table": "Simple Table",
  "Tables": "Tables",
  "Data Table": "Data Table",
  "Permissions": "Permissions",
  "Apps": "Apps",
  "Misc": "Misc",
  "Wizard Pages": "Wizard Pages",
  "Form Wizard": "Form Wizard",
  "Numbered": "Numbered",
  "3": "3",
  "ecommerce": "ecommerce",
  "Ecommerce": "Ecommerce",
  "Editors": "Editors",
  "Front Pages": "Front Pages",
  "Landing": "Landing",
  "checkout": "checkout",
  "Payment": "Payment",
  "Swiper": "Swiper",
  "Product": "Product",
  "Category": "Category",
  "Order": "Order",
  "Details": "Details",
  "Customer": "Customer",
  "Manage Review": "Manage Review",
  "Referrals": "Referrals",
  "Settings": "Settings",
  "Overview": "Overview",
  "My Course": "My Course",
  "Course Details": "Course Details",
  "Academy": "Academy",
  "Logistics": "Logistics",
  "Dashboard": "Dashboard",
  "Fleet": "Fleet",
  "5": "5",
  "10": "10",
  "20": "20",
  "25": "25",
  "50": "50",
  "100": "100",
  "maintenance": "Техникалық қызмет көрсету",
  "maintenance-page": {
    "title": "Техникалық қызмет көрсету параметрлері",
    "notification_section": "Жалпы хабарлама",
    "notification_placeholder": "Барлық пайдаланушылар үшін хабарлама мәтінін енгізіңіз",
    "notification_hint": "Бұл хабарлама барлық аутентификацияланған пайдаланушыларға ескерту ретінде көрсетіледі",
    "games_section": "Сессияларды бұғаттау",
    "games_blocked_label": "Жаңа сессияларды бұғаттау",
    "games_blocked_hint": "Қосылған кезде пайдаланушылар жаңа сессиялар жасай немесе бастай алмайды. Қолданыстағы сессияларға қосылуға болады.",
    "save": "Сақтау",
    "clear": "Тазалау",
    "clear_confirm": "Хабарламаны тазалағыңыз келетініне сенімдісіз бе?",
    "last_updated": "Соңғы жаңартылған",
    "updated_by": "жаңартқан",
    "games_blocked_message": "Қолайсыздық үшін кешірім сұраймыз. Қазіргі уақытта платформада техникалық қызмет көрсету жүргізілуде. Сессиялар уақытша қолжетімсіз."
  },
  "$vuetify": {
    "badge": "Badge",
    "noDataText": "Тізім бос",
    "close": "Жабу",
    "open": "ашу",
    "carousel": {
      "ariaLabel": {
        "delimiter": "delimiter"
      }
    },
    "dataFooter": {
      "itemsPerPageText": "Беттегі саны:",
      "itemsPerPageAll": "Барлығы",
      "pageText": "{0}-{1} из {2}",
      "firstPage": "Бірінші",
      "prevPage": "Алдыңғы",
      "nextPage": "Келесі",
      "lastPage": "Соңғы"
    },
    "pagination": {
      "ariaLabel": {
        "root": "root",
        "previous": "previous",
        "next": "next",
        "first": "first",
        "last": "last",
        "currentPage": "currentPage",
        "page": "page"
      }
    },
    "input": {
      "clear": "clear",
      "appendAction": "appendAction",
      "prependAction": "prependAction",
      "counterSize": "counterSize",
      "otp": "otp"
    },
    "fileInput": {
      "counterSize": "counterSize"
    },
    "rating": {
      "ariaLabel": {
        "item": "item"
      }
    }
  },
  "skill_reports": {
    "skill_development_report": "Дағдыларды дамыту есебі",
    "generate": "Жасау",
    "generate_description": "Таңдалған кезең үшін дағдыларды дамытудың жан-жақты есебін жасаңыз",
    "manager_description": "Ұйымыңыздағы қызметкерлер үшін дағдыларды дамыту есептерін жасаңыз",
    "date": "Күні",
    "competence": "Құзыреттілік",
    "period": "Кезең",
    "status_label": "Күйі",
    "actions": "Іс-әрекеттер",
    "employee": "Қызметкер",
    "view": "Есепті қарау",
    "download_pdf": "PDF жүктеу",
    "no_reports": "Әлі ешқандай есеп жасалмаған",
    "data_not_available": "Есеп деректері әлі қол жетімді емес",
    "generation_failed": "Есепті жасау сәтсіз аяқталды",
    "retry": "Қайталау",
    "rate_limit_exceeded": "Есеп жасау шегіне жеттіңіз. Кейінірек қайталап көріңіз.",
    "too_many_pending": "Орындалуда тым көп есептеріңіз бар. Олар аяқталғанша күтіңіз.",
    "no_games_for_report": "Таңдалған кезең мен құзыреттілік бойынша аяқталған сессиялар табылмады. Есепті жасау мүмкін емес.",
    "report_already_exists": "Осы параметрлермен есеп бұрыннан бар. Төмендегі тізімді тексеріңіз.",
    "period_too_long": "Есеп кезеңі бір жылдан аспауы тиіс.",
    "invalid_parameters": "Құзыреттілік пен кезеңді тексеріңіз",
    "filter_by_employee": "Қызметкер бойынша сүзу...",
    "batch": {
      "mode_single": "Бір есеп",
      "mode_batch": "Топтама",
      "load_employees": "Қызметкерлерді көрсету",
      "sessions": "Сессиялар",
      "no_candidates": "Таңдалған құзыреттілік пен кезең бойынша аяқталған сессиясы бар қызметкерлер жоқ",
      "generate_selected": "Құру ({count})",
      "selected_limit": "Бір уақытта ең көбі {max} қызметкерді таңдауға болады",
      "progress": "{total} есептің {ready} дайын",
      "failed_count": "Қателер: {count}",
      "status_unknown": "Күйі белгісіз",
      "status_unknown_hint": "Есеп тізімнен табылмады — төмендегі есептер кестесін қараңыз",
      "reused": "Қайта пайдаланылған есептер: {count} — соңғы {hours} сағатта құрылған, қайта жасалмады",
      "reused_badge": "Қайта пайдаланылған",
      "reused_on": "{date} құрылған",
      "download_all": "Барлығын жүктеп алу",
      "toggle_details": "Топтама құрамын көрсету",
      "dismiss_confirm": "Топтама әлі жасалуда. Оны экраннан алып тастау керек пе? Орындалу барысы мен «Барлығын жүктеп алу» түймесі жоғалады, есептер төмендегі тізімде қалады.",
      "archive_unavailable": "Мұрағатты жинау мүмкін болмады: кейбір есептер әлі дайын емес немесе енді қолжетімсіз",
      "archive_failed": "Мұрағатты жүктеп алу мүмкін болмады",
      "archive_building": "Мұрағат жиналуда…",
      "archive_build_failed": "Мұрағатты жинау мүмкін болмады. Қайталап көріңіз.",
      "candidates_failed": "Қызметкерлер тізімін жүктеу мүмкін болмады",
      "stale_selection": "Таңдалған қызметкерлердің бір бөлігі енді қолжетімсіз. Тізім жаңартылды — қайта таңдаңыз."
    },
    "quota": {
      "remaining_hour": "Есеп лимиті — сағатына {limit}. Қазір тағы {remaining} есеп сұрауға болады. Қызметкерлерді азайтыңыз немесе {time} уақытында қайталап көріңіз.",
      "remaining_day": "Есеп лимиті — күніне {limit}. Қазір тағы {remaining} есеп сұрауға болады. Қызметкерлерді азайтыңыз немесе {time} уақытында қайталап көріңіз.",
      "exhausted_hour": "Есеп лимиті ({limit} сағатына) таусылды. Ол {time} уақытында жаңарады.",
      "exhausted_day": "Есеп лимиті ({limit} күніне) таусылды. Ол {time} уақытында жаңарады.",
      "too_large_hour": "Есеп лимиті — сағатына {limit}. Қызметкерлерді азайтыңыз.",
      "too_large_day": "Есеп лимиті — күніне {limit}. Қызметкерлерді азайтыңыз."
    },
    "status": {
      "pending": "Күтуде",
      "collecting_data": "Деректер жиналуда...",
      "analyzing": "ЖИ талдауы...",
      "generating_pdf": "PDF жасалуда...",
      "ready": "Дайын",
      "failed": "Сәтсіз"
    },
    "report": {
      "kicker": "Құзыреттілікті дамыту есебі",
      "position": "Лауазым",
      "department": "Бөлім",
      "period": "Кезең",
      "games_count": "Өткізілген сессиялар",
      "not_specified_f": "Көрсетілмеген",
      "not_specified_n": "Көрсетілмеген",
      "fig": {
        "your_average": "Сіздің орташа балыңыз",
        "company_average": "Компания орташасы",
        "participants": "Кезеңдегі қатысушылар",
        "skills_count": "Бағаланған дағдылар"
      },
      "sec": {
        "profile": "Құзыреттілік профилі",
        "trend": "Сессиялар бойынша динамика",
        "strengths": "Неге сүйенуге болады",
        "priorities": "Дамудың үш басымдығы",
        "skills": "Дағдылар бойынша талдау",
        "plan": "Үш айлық жоспар"
      },
      "legend": {
        "you": "Сіздің балыңыз",
        "company": "Компания орташасы"
      },
      "dotplot_caption": "Орташадан ауытқу — ең үлкен артықшылықтан ең үлкен артта қалуға дейін",
      "trend_disclaimer": "Жекелеген сессиялардың баллдары тікелей салыстыруға келмейді: кейстердің күрделілігі сессиядан сессияға өзгереді. Баллдың төмендеуі өздігінен дағдының нашарлағанын білдірмейді — бұл график баға емес, бақылау.",
      "no_comparison": "Компания орташасымен салыстыру қолжетімсіз: осы кезеңде бұл құзыреттілік бойынша үштен аз адам сессия өткізген. Есеп абсолютті баллдарға негізделген.",
      "skill": {
        "works": "Не сәтті шығады",
        "blocks": "Не кедергі келтіреді",
        "actions": "Не істеу керек",
        "out_of_ten": "10 балдық шкалада",
        "company_short": "компания"
      },
      "level": {
        "outstanding": "Үздік нәтиже",
        "strength": "Күшті жағы",
        "meets_standard": "Компания деңгейінде",
        "needs_attention": "Назар аударуды қажет етеді",
        "needs_development": "Даму аймағы"
      },
      "plan": {
        "month": "Ай",
        "goals": "Мақсаттар",
        "actions": "Іс-әрекеттер"
      },
      "colophon": {
        "built_on": "Есеп {from} — {to} кезеңіндегі сессиялар негізінде жасалды. Сессиялар саны: {count}.",
        "comparison": "Салыстыру сол кезеңдегі компания орташасымен жүргізілді. Қатысушылар саны: {count}."
      }
    }
  },
    "api-tokens": "API Токендері",
    "api-tokens-page": {
        "select_user": "Пайдаланушы",
        "select_user_hint": "API токендерін көру және басқару үшін пайдаланушыны таңдаңыз.",
        "no_users_found": "Пайдаланушылар табылмады",
        "no_tokens": "Бұл пайдаланушының API токендері жоқ.",
        "token_name": "Атауы",
        "abilities": "Мүмкіндіктер",
        "ability": "Мүмкіндік",
        "created_at": "Жасалған күні",
        "last_used_at": "Соңғы пайдаланылған күні",
        "expires_at": "Мерзімі аяқталады",
        "actions": " ",
        "issue_token": "Токен беру",
        "issue": "Беру",
        "issue_failed": "Токенді беру сәтсіз аяқталды",
        "token": "Токен",
        "plaintext_warning": "Бұл токенді қазір көшіріп алыңыз — ол қайтадан көрсетілмейді.",
        "revoke": "Қайтарып алу",
        "revoke_confirm": "Бұл токенді қайтарып алғыңыз келетініне сенімдісіз бе? Оны пайдаланатын интеграциялар жұмысын тоқтатады."
    },
  "subscription": {
    "current_plan": "Ағымдағы жоспар",
    "expires_at": "Мерзімі аяқталады: {date}",
    "no_active_plan": "Белсенді жазылым жоспары жоқ",
    "quota_warning": "Квота аз қалды",
    "regular_games": "Кәдімгі сессиялар",
    "ai_games": "AI сессиялар",
    "any_games": "Кез келген сессиялар",
    "used_of": "{limit} ішінен {used}",
    "remaining": "Қалды: {count}",
    "quota_exceeded": "Квота асып кетті",
    "tickets_only": "Кредит пакеттері",
    "session_package": "Сессиялар пакеті",
    "games_available": "Сессиялар",
    "users": "Пайдаланушылар",
    "active_users": "Белсенді пайдаланушылар",
    "active_tickets": "Кредит пакеттері",
    "ticket_charges": "{charges} кредит",
    "ticket_no_expiry": "Мерзімсіз",
    "unlimited": "Шексіз",
    "no_game_limits": "Сессиялар санына шектеу жоқ"
  },
  "knowledge-base-page": {
    "provider-unsupported": "Білім қоры сіздің ұйымыңыздың ағымдағы AI провайдерінде қол жетімді емес."
  },
  "candidate-page": {
    "document_title": "Сұхбат",
    "greeting": "Сәлеметсіз бе, {name}!",
    "intro_lead": "{organization} сізді «{vacancy}» вакансиясы бойынша виртуалды әңгімелесушімен сұхбатқа шақырады.",
    "duration": "Сұхбат шамамен {minutes} минутке созылады.",
    "requirements_title": "Не қажет болады",
    "requirement_mic": "Жұмыс істейтін микрофон, құлаққап болса — тіпті жақсы",
    "requirement_camera_required": "Қосулы камера: бұл сұхбат үшін ол міндетті",
    "requirement_camera_optional": "Камера міндетті емес, бірақ онымен әңгіме анағұрлым табиғи өтеді",
    "requirement_browser": "Компьютер және Chrome, Edge немесе Safari браузерінің жаңа нұсқасы",
    "requirement_network": "Тұрақты интернет-байланыс және ешкім бөлмейтін тыныш орын",
    "continue": "Жалғастыру",
    "consent": {
      "accept": "Мәтінмен таныстым және дербес деректерімді өңдеуге келісім беремін",
      "back": "Артқа",
      "start": "Сұхбатты бастау"
    },
    "terminal": {
      "finished": {
        "title": "Рахмет!",
        "text": "Сұхбат аяқталды, нәтиже рекрутерге жіберілді — ол сізбен байланысады. Бұл бетті жабуға болады."
      },
      "already_completed": {
        "title": "Сұхбат бұрын аяқталған",
        "text": "Бұл сілтеме бойынша сұхбат аяқталған. Оны қайта тапсыру қажет болса, рекрутермен байланысыңыз."
      },
      "not_found": {
        "title": "Сілтеме табылмады",
        "text": "Мекенжайда қате болуы мүмкін немесе сілтеме енді жарамсыз. Рекрутердің хатын тексеріңіз немесе онымен байланысыңыз."
      },
      "session_conflict": {
        "title": "Сіз басқа аккаунтқа кіргенсіз",
        "text": "Ағымдағы аккаунттан шығыңыз немесе сілтемені браузердің жасырын режимінде ашыңыз."
      },
      "link_revoked": {
        "title": "Сілтеме бойынша қолжетімділік жабылды",
        "text": "Рекрутер бұл сілтемені қайтарып алды. Жаңа сілтеме алу үшін онымен байланысыңыз."
      },
      "link_expired": {
        "title": "Сілтеменің мерзімі аяқталды",
        "text": "Жаңа сілтеме алу үшін рекрутермен байланысыңыз."
      },
      "attempts_exhausted": {
        "title": "Талпыныстар аяқталды",
        "text": "Бұл сілтеме бойынша барлық талпыныс қолданылды. Рекрутермен байланысыңыз."
      },
      "unavailable": {
        "title": "Қазір бастау мүмкін емес",
        "text": "Кейінірек қайталап көріңіз немесе рекрутермен байланысыңыз."
      },
      "rate_limited": {
        "title": "Талпыныстар тым көп",
        "text": "Бір минут күтіп, бетті жаңартыңыз."
      },
      "aborted": {
        "title": "Сұхбат басталмады",
        "text": "Бетті жаңартып, қайта көріңіз. Көмектеспесе, рекрутермен байланысыңыз."
      },
      "generic": {
        "title": "Қате орын алды",
        "text": "Бетті жаңартып, қайта көріңіз. Көмектеспесе, рекрутермен байланысыңыз."
      }
    }
  },
  "recruiting-page": {
    "title": "Іріктеу",
    "create": "Вакансия жасау",
    "edit": "Вакансияны өңдеу",
    "empty": "Әзірге вакансиялар жоқ",
    "load_error": "Вакансиялар тізімін жүктеу мүмкін болмады",
    "retry": "Қайталау",
    "back": "Вакансиялар тізіміне қайту",
    "open": "Кандидаттар",
    "archive": "Мұрағатқа",
    "no_expiry": "Мерзімсіз",
    "confirm_archive": "Вакансияны мұрағатқа жіберу керек пе? Бұдан кейін ол бойынша жаңа сілтемелер шығаруға болмайды.",
    "headers": {
      "title": "Вакансия",
      "scenario": "Сценарий",
      "status": "Мәртебе",
      "expires_at": "Жарамды мерзімі",
      "actions": "Әрекеттер"
    },
    "status": {
      "draft": "Жоба",
      "active": "Белсенді",
      "archived": "Мұрағатта"
    },
    "dialog": {
      "title_label": "Вакансия атауы",
      "scenario_label": "Сұхбат сценарийі",
      "scenario_placeholder": "AI-мен ойын үшін сценарий таңдаңыз",
      "scenario_hint": "Тек AI-мен ойынға жарамды сценарийлер қолжетімді",
      "status_label": "Мәртебе",
      "expires_label": "Жарамды мерзімі",
      "expires_hint": "Бос қалдырсаңыз — вакансия мерзімсіз болады",
      "save": "Сақтау",
      "cancel": "Бас тарту"
    },
    "messages": {
      "created": "Вакансия жасалды",
      "updated": "Вакансия жаңартылды",
      "archived": "Вакансия мұрағатқа жіберілді",
      "revoked": "Сілтеме қайтарып алынды",
      "attempt_granted": "Кандидатқа тағы бір талпыныс қосылды",
      "copied": "Сілтеме көшірілді",
      "error": "Қате орын алды"
    },
    "candidates": {
      "title": "Кандидаттар",
      "empty": "Бұл вакансия бойынша әлі бірде-бір сілтеме шығарылған жоқ",
      "load_error": "Кандидаттар тізімін жүктеу мүмкін болмады",
      "issue": "Сілтеме беру",
      "import": "Файлдан импорттау",
      "expired": "Мерзімі аяқталды",
      "no_games": "Сұхбат басталған жоқ",
      "attempts": "{allowed} ішінен {used}",
      "revoke": "Сілтемені қайтарып алу",
      "extra_attempt": "Тағы бір талпыныс беру",
      "open_result": "Сұхбат нәтижесін ашу",
      "confirm_revoke": "Кандидаттың сілтемесін қайтарып алу керек пе? Қолжетімділік дереу жоғалады, соның ішінде жүріп жатқан сұхбатқа да.",
      "confirm_extra_attempt": "Кандидатқа тағы бір талпыныс беру керек пе?",
      "headers": {
        "candidate": "Кандидат",
        "link_status": "Сілтеме",
        "invite": "Шақыру",
        "game_status": "Сұхбат",
        "attempts": "Талпыныстар",
        "expires_at": "Сілтеменің жарамды мерзімі",
        "actions": "Әрекеттер"
      },
      "link_status": {
        "created": "Берілді",
        "opened": "Ашылды",
        "in_progress": "Сұхбат жүріп жатыр",
        "completed": "Сұхбат аяқталды",
        "revoked": "Қайтарып алынды"
      },
      "invite_status": {
        "not_sent": "Жіберілмеген",
        "queued": "Кезекте",
        "sent": "Жіберілді",
        "failed": "Жіберу сәтсіз аяқталды"
      },
      "invite_sent_at": "Пошта қызметі хатты қабылдады: {date}",
      "invite_failure": {
        "rejected": "Пошта қызметі хатты қабылдамады — сілтемені кандидатқа өзіңіз жіберіңіз",
        "transport": "Жіберу кезінде ақау туындады — сілтемені кандидатқа өзіңіз жіберіңіз",
        "revoked": "Сілтеме қайтарып алынды",
        "sending_disabled": "Хаттарды жіберу өшірулі",
        "blocked": "Мекенжай стоп-тізімде — сілтемені кандидатқа өзіңіз жіберіңіз"
      }
    },
    "issue_dialog": {
      "title": "Жеке сілтеме беру",
      "name": "Аты",
      "last_name": "Тегі",
      "email": "Email",
      "phone": "Телефон",
      "attempts": "Талпыныстар саны",
      "expires_at": "Сілтеменің жарамды мерзімі",
      "expires_hint": "Бос қалдырсаңыз — мерзім вакансиядан алынады",
      "submit": "Сілтеме беру",
      "close": "Жабу",
      "result_title": "Сілтеме берілді",
      "warning": "Бұл сілтемені қазір көшіріп алыңыз — ол тек бір рет көрсетіледі. Базада тек оның хэші сақталады, сілтемені қалпына келтіру мүмкін емес: жоғалтылған сілтемені қайтарып алып, қайта беру керек болады.",
      "copy": "Көшіру",
      "copied": "Көшірілді",
      "send_invite": "Шақыруды мына мекенжайға жіберу: {email}",
      "send_invite_no_email": "Шақыруды email арқылы жіберу",
      "send_invite_blocked": "Бұл мекенжай стоп-тізімде — хат жіберілмейді",
      "invite_queued": "Шақыру кезекке қойылды: {email}",
      "invite_blocked": "Шақыру жіберілмеді: {email} стоп-тізімде. Сілтемені кандидатқа өзіңіз жіберіңіз"
    },
    "import_dialog": {
      "title": "Кандидаттарды импорттау",
      "subtitle": "Файлдың әр жолы — бір кандидат және бір жеке сілтеме.",
      "file": "Кандидаттар тізімі файлы",
      "columns": "Бағандар: Аты, Тегі, Email, Телефон",
      "limits": "xlsx немесе «;» CSV: 200 жолға, 10 МБ-ға дейін",
      "size_error": "Файл 10 МБ-тан үлкен",
      "download_example": "Үлгіні жүктеу",
      "note_title": "Сілтемелер тек жүктеп алынған файлда көрінеді",
      "note_text": "Файл импорттан кейін бірден жүктеледі. Базада тек сілтемелердің хэші сақталады — оларды екінші рет шығару мүмкін емес, файлды сақтап қойыңыз.",
      "submit": "Импорттау",
      "cancel": "Бас тарту",
      "result_title": "Сілтемелер берілді",
      "result": "Берілген сілтеме саны: {count}. Файл жүктелді.",
      "invites_blocked": "Жіберілмеген шақыру саны: {count}. Бұл мекенжайлар стоп-тізімде — сілтемелерді осы кандидаттарға өзіңіз жіберіңіз.",
      "saved_title": "Жүктеп алынған файлды сақтаңыз",
      "saved_text": "Бұл сілтемелердің жалғыз көшірмесі: базада тек олардың хэші сақталады. Жоғалған сілтемені тек қайтарып алып, қайта беруге болады.",
      "download_again": "Файлды қайта жүктеу",
      "errors_title": "Қабылданбаған жолдар",
      "error_row": "{row}-жол: {error}",
      "errors_truncated": "…тағы қабылданбаған жол саны: {count}. Тізімде алғашқы 50-і көрсетілген.",
      "send_invites": "Шақыруларды кандидаттарға email арқылы жіберу",
      "send_invites_hint": "Email мекенжайы жоқ кандидаттарға хат жіберілмейді"
    }
  },
  "ai-reports": "ЖИ-есептер",
  "ai-reports-page": {
    "title": "ЖИ-есептер",
    "subtitle": "Есепті өз сөзіңізбен сипаттаңыз — сипаттамасын жасаймыз, алдын ала қараймыз және Excel-ге экспорттаймыз.",
    "status": {
      "draft": "Жоба",
      "pending": "Жасалып жатыр",
      "ready": "Дайын",
      "failed": "Жасалмады"
    },
    "list": {
      "title": "Менің есептерім",
      "new": "Жаңа есеп",
      "empty": "Әзірге есептер жоқ. «Жаңа есеп» түймесін басып, нені көрсету керектігін сипаттаңыз.",
      "untitled": "Атаусыз",
      "delete": "Есепті жою",
      "delete_confirm": "Есепті жасалған файлмен бірге жою керек пе?",
      "deleted": "Есеп жойылды"
    },
    "dialog": {
      "title": "Диалог",
      "open_dictionary": "Деректер анықтамалығы",
      "placeholder": "Мысалы: соңғы тоқсанда әр бөлім қанша ойын өткізді",
      "send": "Жіберу",
      "empty_title": "Есепте не көрсетілуі керек?",
      "empty_text": "Қарапайым сөзбен жазыңыз: қандай деректер, қай кезең үшін және қандай бөлініс бойынша. Бір нәрсе жетіспесе, қосымша сұраймын.",
      "examples_title": "Мысалы:",
      "examples": {
        "e1": "Соңғы тоқсанда әр бөлім қанша ойын өткізді",
        "e2": "2026 жылы сату бөлімінде дағдылар бойынша орташа балл",
        "e3": "Бір айдан астам ойнамаған қызметкерлер",
        "e4": "Соңғы 30 күндегі вакансиялар бойынша кандидаттар және олардың сілтеме мәртебелері"
      },
      "thinking": "Есеп жасалып жатыр…",
      "waiting_hint": "Жауап осында өзі шығады — бетті жаңартудың қажеті жоқ.",
      "retry": "Қайталау",
      "dismiss": "Жасыру",
      "spec_ready": "Есеп дайын — төмендегі алдын ала көріністі тексеріп, файлды жасаңыз.",
      "stuck_title": "Біз шеңбер бойымен жүріп жатқан сияқтымыз",
      "stuck_text": "Деректер анықтамалығын ашып, сұранымды сол жердегі сөздермен қайта тұжырымдаңыз — бұл тағы бір нақтылау сұрағына жауап беруден жылдамырақ.",
      "rejected_title": "Бұл есепті әзірге жасау мүмкін емес",
      "reason": {
        "no_such_measure": "Мұндай көрсеткіш біздің деректерде жоқ. Анықтамалықтағы көрсеткіштер тізімін қараңыз.",
        "no_such_field": "Мұндай өріс біздің деректерде жоқ. Анықтамалықтағы өрістер тізімін қараңыз.",
        "cross_dataset": "Сұраным бір мезгілде екі деректер жиынтығынан деректерді талап етеді. Оны екі есепке бөліңіз.",
        "window_function": "Жалпы соманың үлестері, рейтингтегі орындар және алдыңғы кезеңмен салыстыру әлі қолдау таппайды.",
        "other": "Сұраным қолжетімді деректерден асып кетеді. Анықтамалықты қарап, басқаша тұжырымдап көріңіз."
      },
      "usage": {
        "employees": "қызметкер жоқ | {n} қызметкер | {n} қызметкер",
        "games": "ойын жоқ | {n} ойын | {n} ойын",
        "scenarios": "сценарий жоқ | {n} сценарий | {n} сценарий",
        "evaluations": "баға жоқ | {n} баға | {n} баға",
        "candidates": "кандидат жоқ | {n} кандидат | {n} кандидат"
      },
      "option_created_at": "{date} қосылды"
    },
    "preview": {
      "title": "Алдын ала қарау",
      "no_report": "Сол жақтан есепті таңдаңыз немесе жаңасын бастаңыз.",
      "no_spec": "Есепті диалогта сипаттаңыз — сұраным түсінілгеннен кейін алдын ала көрініс пайда болады.",
      "spec_title": "Есепте не болады",
      "rows_hint": "Алғашқы {count} жол көрсетілген",
      "total": "Барлығы жол саны: {count}",
      "zero_rows": "Бұл сұраным бойынша бірде-бір жол жоқ. Кезеңді кеңейтіңіз немесе сүзгілерді алып тастаңыз — бос файл жасаудың қажеті жоқ.",
      "zero_rows_hint": "Сүзгі мәндерін тексеріңіз — олар бойынша деректер болмауы мүмкін",
      "duplicate_rows": "Алдын ала қарауда бірдей жолдар бар: таңдалған бағандар осы деректер жиынтығының жазбаларын ажыратпайды. Бір жол шын мәнінде нені білдіретінін тексеріңіз — ажырататын баған жетіспеуі мүмкін.",
      "too_many_rows": "Есепте {count} жол бар, ең көбі — {max}. Кезеңді тарылтыңыз немесе сүзгі қосыңыз: шек асып кеткенде файл қысқартылмайды, мүлдем жасалмайды.",
      "generate": "Файлды жасау",
      "regenerate": "Қайта жасау",
      "queued": "Файл жасалып жатыр — дайын болған соң карточка өзі жаңарады.",
      "failed": "Есепті жасау мүмкін болмады",
      "download": ".xlsx жүктеп алу",
      "downloads": "Жүктеп алулар саны: {count}",
      "ttl_warning": "Файл {days} күн сақталады, содан кейін жойылады — оны бірден жүктеп алыңыз.",
      "expires_at": "{date} дейін қолжетімді",
      "expired": "Файл сақтау мерзімі бойынша жойылды — есепті қайта жасаңыз."
    },
    "spec": {
      "dataset": "Деректер",
      "columns": "Бағандар",
      "measures": "Көрсеткіштер",
      "group_by": "Бөліну",
      "period": "Кезең",
      "period_value": "{field}: {from} бастап {to} дейін",
      "period_all": "Барлық қолжетімді кезең",
      "filters": "Сүзгілер",
      "having": "Көрсеткіштер бойынша шарттар",
      "sort": "Сұрыптау",
      "limit": "Жолдар шегі",
      "limit_value": "алғашқы {count} жол",
      "granularity": {
        "year": "жыл бойынша",
        "quarter": "тоқсан бойынша",
        "month": "ай бойынша",
        "week": "апта бойынша",
        "day": "күн бойынша",
        "dow": "апта күні бойынша"
      },
      "dir": {
        "asc": "өсу ретімен",
        "desc": "кему ретімен"
      },
      "filter": {
        "equals": "{field} — {value}",
        "not_equals": "{field} — {value} емес",
        "in": "{field} — мыналардың бірі: {value}",
        "not_in": "{field} — мыналардан басқа: {value}",
        "gt": "{field} {value}-дан көп",
        "gte": "{field} кемінде {value}",
        "lt": "{field} {value}-дан аз",
        "lte": "{field} көбі дегенде {value}",
        "contains": "{field} құрамында «{value}» бар",
        "between": "{field} — {from} бастап {to} дейін",
        "is_null": "{field} толтырылмаған",
        "is_not_null": "{field} толтырылған"
      }
    },
    "value": {
      "yes": "Иә",
      "no": "Жоқ"
    },
    "dictionary": {
      "title": "Деректер анықтамалығы",
      "subtitle": "Есепке қосуға болатын барлық нәрсе. Тізім тікелей: ол сипаттама жасалатын тізіммен бірдей.",
      "fields": "Өрістер",
      "measures": "Көрсеткіштер",
      "values": "Мәндер",
      "show_values": "Ұйымыңыздың мәндерін көрсету",
      "hide_values": "Мәндерді жасыру",
      "values_error": "Мәндерді жүктеу мүмкін болмады — қайталап көріңіз.",
      "values_empty": "Ұйымыңызда бұл өріс бойынша әзірге мән жоқ.",
      "limits": {
        "title": "Есеп нені істей алмайды",
        "pivot": "«Әр қатысушыға бір баған» немесе «әр сұраққа бір баған» түріндегі жиынтық кесте жиналмайды. Оның орнына ұзын пішінді сұраңыз: әр «қатысушы — сұрақ» жұбына бір жол.",
        "window": "Есеп айдан айға өзгерісті, жалпыдан үлесті, рейтингтегі орынды және «әр бөлімдегі үздік үшеуді» есептемейді. Айлар бойынша бөліністі алып, қалғанын Excel-де есептеңіз.",
        "missing": "Жүйе сақтамайтын нәрсе есепте де болмайды: жалақылар, NPS және басқа жүйелердегі өзге деректер ешбір атаумен шықпайды."
      },
      "empty": "Анықтамалық бос — әкімшіге хабарласыңыз.",
      "close": "Жабу"
    },
    "errors": {
      "generic": "Бірдеңе дұрыс болмады. Қайталап көріңіз.",
      "detail": "Түсінікті болмады: {value}",
      "rate_limit": "Сұраныс тым жиі. Бір минут күтіп, қайталаңыз.",
      "download": "Файлды жүктеп алу мүмкін болмады.",
      "turn_failed": "Жауап алу мүмкін болмады. Сұранысты қайта жіберіңіз.",
      "turn_stuck_in_queue": "Сұраныс өңдеуге жеткен жоқ — ол кезекте тым ұзақ күтті. Оны қайта жіберіңіз.",
      "unknown_resolution": "Бұл нұсқа ескірген — есеп сұрауы өзгеріп үлгерді. Оны қайта ашып, сұранысты нақтылаңыз."
    }
  },
    "externalLaunch": {
        "document_title": "Жаттығу сессиясы",
        "intro": {
            "title": "Жаттығу сұхбаты",
            "lead": "Қазір сіз виртуалды әңгімелесушімен сөйлесесіз. Сұхбат жазылады және бағаланады, ал нәтиже сіздің оқыту жүйеңізге қайтарылады.",
            "requirements_title": "Не қажет болады",
            "requirement_mic": "Жұмыс істейтін микрофон, жақсысы гарнитура",
            "requirement_camera": "Камера міндетті емес, бірақ онымен сұхбат табиғи болады",
            "requirement_browser": "Жаңартылған Chrome, Edge немесе Safari бар компьютер",
            "requirement_network": "Тұрақты байланыс және сізге ешкім кедергі жасамайтын тыныш орын",
            "start": "Бастау"
        },
        "relaunch_hint": "Оқыту жүйеңізге оралып, материалды қайта ашыңыз.",
        "saving": "Нәтиже сақталуда…",
        "review": {
            "document_title": "Сессия шолуы",
            "attempt": "{number}-әрекет",
            "result": {
                "passed": "Өтті",
                "failed": "Өтпеді",
                "pending": "Бағасы әлі жоқ"
            },
            "score_of_100": "100-ден {score}",
            "threshold": "Өту шегі: {threshold}",
            "skills_title": "Дағдылар мен ұсыныстар",
            "skills_empty": "Бұл әрекет бойынша дағдылар кесіндісінде пікір әлі жоқ.",
            "comments_title": "Жазбаға пікірлер",
            "comments_empty": "Бұл жазбаға пікір жоқ.",
            "loading": "Шолу жүктелуде",
            "error": {
                "not_found": {
                    "title": "Сілтеме жұмыс істемейді",
                    "text": "Шолу енді қолжетімді емес: сілтеменің мерзімі өтті немесе әрекет қайтарылды."
                },
                "expired": {
                    "title": "Бет ескірді",
                    "text": "Шолуды оқыту жүйеңіздегі сілтеме арқылы қайта ашыңыз."
                },
                "generic": {
                    "title": "Шолуды көрсету мүмкін болмады",
                    "text": "Біздің жағымызда бірдеңе дұрыс болмады. Сілтемені қайта ашып көріңіз."
                }
            }
        },
        "terminal": {
            "finished": {
                "title": "Рақмет!",
                "text": "Сұхбат аяқталды. Баға дайын болған соң нәтиже оқыту жүйеңізде пайда болады. Бұл бетті жабуға болады."
            },
            "aborted": {
                "title": "Сұхбат басталмады",
                "text": "Сұхбат басталмас бұрын бірдеңе дұрыс болмады."
            },
            "token_expired": {
                "title": "Сессияның мерзімі өтті",
                "text": "Бұл сұхбатқа қолжетімділік енді жарамсыз."
            },
            "not_found": {
                "title": "Сілтеме жұмыс істемейді",
                "text": "Мекенжайда қате болуы мүмкін немесе сілтеме енді жарамсыз."
            },
            "rate_limited": {
                "title": "Әрекеттер тым көп",
                "text": "Қайта көрмес бұрын бір минут күтіңіз."
            },
            "generic": {
                "title": "Қазір бастау мүмкін емес",
                "text": "Біздің жағымызда бірдеңе дұрыс болмады."
            }
        },
        "refusal": {
            "publication_disabled": {
                "title": "Материал жабық",
                "text": "Бұл материал жаттығу үшін енді қолжетімді емес."
            },
            "publication_draft": {
                "title": "Материал әлі жарияланбаған",
                "text": "Бұл материал бойынша жаттығу әлі ашылмаған."
            },
            "publication_expired": {
                "title": "Материалдың мерзімі өтті",
                "text": "Бұл материал бойынша жаттығуға болатын мерзім аяқталды."
            },
            "feature_disabled": {
                "title": "Материал жабық",
                "text": "Оқыту жүйесінен жаттығуды бастау сіздің ұйымыңыз үшін өшірілген."
            },
            "connection_disabled": {
                "title": "Материал жабық",
                "text": "Сіздің оқыту жүйеңізбен байланыс өшірілген. Курсты тағайындаған адамға хабарласыңыз."
            },
            "launch_limit_reached": {
                "title": "Шекке жетті",
                "text": "Бұл материал бойынша сұхбаттардың ең көп саны өткізілді."
            },
            "daily_budget_exhausted": {
                "title": "Бүгінге жеткілікті",
                "text": "Сіз тәулігіне рұқсат етілген сұхбат санына жеттіңіз. Ертең қайта көріңіз."
            },
            "attempts_exhausted": {
                "title": "Әрекет қалмады",
                "text": "Сіз бұл материал бойынша рұқсат етілген барлық әрекетті пайдаландыңыз."
            },
            "quota_exhausted": {
                "title": "Қазір бастау мүмкін емес",
                "text": "Сіздің ұйымыңызда сұхбат қалмады. Курсты тағайындаған адамға хабарласыңыз."
            },
            "user_limit_reached": {
                "title": "Қазір бастау мүмкін емес",
                "text": "Сіздің ұйымыңызда бос орын қалмады. Курсты тағайындаған адамға хабарласыңыз."
            },
            "scenario_unavailable": {
                "title": "Материал қолжетімсіз",
                "text": "Бұл материалдың артындағы сұхбат енді жоқ."
            },
            "assignment_check_unavailable": {
                "title": "Қазір бастау мүмкін емес",
                "text": "Бұл материалдың сізге тағайындалғанын растай алмадық. Курсты тағайындаған адамға хабарласыңыз."
            },
            "code_invalid": {
                "title": "Сілтеме енді жарамсыз",
                "text": "Бұл сілтеме бұрын пайдаланылған немесе оның мерзімі өткен."
            },
            "channel_verification_failed": {
                "title": "Оқыту жүйесі жауап бермеді",
                "text": "Сұранымды оқыту жүйеңізбен растай алмадық."
            },
            "external_system_unavailable": {
                "title": "Оқыту жүйесі жауап бермей тұр",
                "text": "Оқыту жүйесінде курсқа тағайындалуыңызды тексере алмадық. Бірнеше минуттан кейін қайталап көріңіз."
            },
            "user_not_found": {
                "title": "Сізді анықтай алмадық",
                "text": "Мұнда сізге арналған тіркелгі жоқ, ал сіздің ұйымыңыз тіркелгілерді автоматты түрде жасамайды. Курсты тағайындаған адамға хабарласыңыз."
            },
            "user_unavailable": {
                "title": "Сіздің тіркелгіңіз өшірілген",
                "text": "Курсты тағайындаған адамға хабарласыңыз."
            },
            "user_deleted": {
                "title": "Сіздің тіркелгіңіз жойылған",
                "text": "Курсты тағайындаған адамға хабарласыңыз."
            },
            "email_taken_linking_disabled": {
                "title": "Сізді анықтай алмадық",
                "text": "Сіздің электрондық пошта мекенжайыңыз мұнда басқа тіркелгіге тиесілі. Курсты тағайындаған адамға хабарласыңыз."
            },
            "service_role_not_allowed": {
                "title": "Бұл тіркелгімен жаттығу мүмкін емес",
                "text": "Әкімші тіркелгілері жаттығу сұхбаттарына қатыспайды. Өзіңіздің оқу тіркелгіңізді пайдаланыңыз."
            },
            "unverified_request": {
                "title": "Сұранымды растай алмадық",
                "text": "Оқыту жүйеңіз бұл сұхбатты сіз бастағаныңызды растамады."
            }
        },
        "manage": {
            "nav": {
                "group": "Сыртқы іске қосу",
                "publications": "Жарияланымдар",
                "connections": "LMS байланыстары"
            },
            "messages": {
                "error": "Бірдеңе дұрыс болмады. Қайталап көріңіз.",
                "load_error": "Деректерді жүктеу мүмкін болмады."
            },
            "connections": {
                "title": "LMS байланыстары",
                "subtitle": "Осы ұйым жаттығуды іске қосатын оқыту жүйелерінің тіркелгілері.",
                "create": "Байланыс қосу",
                "edit": "Өңдеу",
                "set_credentials": "Тіркелу деректерін орнату",
                "empty": "Байланыстар әлі жоқ.",
                "secret_missing": "Орнатылмаған",
                "no_expiry": "Мерзімі жоқ",
                "headers": {
                    "account": "Тіркелгі",
                    "base_url": "Мекенжай",
                    "client_id": "Клиент идентификаторы",
                    "secret": "Құпия",
                    "status": "Мәртебе",
                    "expires_at": "Тіркелу деректерінің мерзімі",
                    "actions": " "
                },
                "status": {
                    "no_credentials": "Тіркелу деректері жоқ",
                    "active": "Белсенді",
                    "expired": "Тіркелу деректерінің мерзімі өтті",
                    "disabled": "Өшірілген"
                },
                "lms": {
                    "ispring": "iSpring Learn"
                },
                "dialog": {
                    "create_title": "Жаңа байланыс",
                    "edit_title": "Байланыс",
                    "immutable_hint": "Оқыту жүйесі мен тіркелгіні өзгерту мүмкін емес: олар білім алушының сәйкестендіру кеңістігін анықтайды. Басқа тіркелгі — жаңа байланыс.",
                    "lms_label": "Оқыту жүйесі",
                    "account_key_label": "Тіркелгі",
                    "account_key_hint": "Оқыту жүйесіндегі тіркелгі идентификаторы.",
                    "base_url_label": "iSpring REST API мекенжайы",
                    "base_url_hint": "Мысалы, https://api-learn.ispringlearn.ru. Бұл компания порталының мекенжайы емес: құпия осы мекенжайға жіберіледі.",
                    "base_url_https": "Мекенжай https:// -дан басталуы керек",
                    "enabled_label": "Байланыс қосулы",
                    "enabled_hint": "Байланыс ешқашан жойылмайды — ол өшіріледі. Жарияланымдар мен іске қосулар тізімде қалады, бірақ жаңа іске қосулардан бас тартылады және нәтижелер оқыту жүйесіне бұдан былай жіберілмейді.",
                    "credentials_optional": "Тіркелу деректері міндетті емес. Оларсыз байланыс шектеулі режимде жұмыс істейді.",
                    "client_id_label": "Клиент идентификаторы",
                    "secret_label": "Құпия",
                    "secret_hint": "Шифрланған түрде сақталады. Оны кері оқу мүмкін емес — тек соңғы төрт таңба көрсетіледі.",
                    "expires_at_label": "Тіркелу деректерінің мерзімі",
                    "expires_at_hint": "Тіркелу деректерінің мерзімі болмаса, бос қалдырыңыз."
                },
                "credentials_dialog": {
                    "title": "Тіркелу деректері",
                    "lead": "Жаңа құпия алдыңғысын алмастырады. Байланыс өз идентификаторын сақтайды, ал білім алушылардың сілтемелері мен іске қосулары өз орнында қалады.",
                    "secret_hint": "Алдыңғы құпия енді қажет емес және оны кері оқу мүмкін емес."
                },
                "messages": {
                    "saved": "Байланыс сақталды",
                    "credentials_saved": "Тіркелу деректері сақталды"
                }
            },
            "publications": {
                "title": "Жарияланымдар",
                "subtitle": "Оқыту жүйесінен іске қосу үшін ашылған сценарийлер.",
                "create": "Жаңа жарияланым",
                "edit": "Өңдеу",
                "enable": "Қосу",
                "disable": "Өшіру",
                "open_journal": "Журнал",
                "download_package": "Топтаманы жүктеп алу",
                "empty": "Жарияланымдар әлі жоқ.",
                "no_connections": "Оқыту жүйесімен байланыс әлі жоқ. Оны платформа әкімшісі орнатады.",
                "no_expiry": "Мерзімі жоқ",
                "attempts_unlimited": "Шектеусіз",
                "immutable_hint": "Байланысты, сценарийді және жеткізу арнасын өзгерту мүмкін емес: олар оқыту жүйесіне жүктелген топтамаға енгізілген. Қалғанының бәрі оны қайта құрмай-ақ қолданылады.",
                "headers": {
                    "scenario": "Сценарий",
                    "connection": "Байланыс",
                    "channel": "Арна",
                    "status": "Мәртебе",
                    "settings": "Параметрлер",
                    "expires_at": "Мерзімі",
                    "actions": " "
                },
                "summary": {
                    "attempts": "Әрекеттер: {value}",
                    "threshold": "Өту шегі: {value}"
                },
                "status": {
                    "draft": "Жоба",
                    "active": "Белсенді",
                    "disabled": "Өшірілген"
                },
                "channel": {
                    "scorm_1_2": "SCORM 1.2",
                    "scorm_2004": "SCORM 2004"
                },
                "result_mode": {
                    "status_only": "Тек мәртебе",
                    "status_and_score": "Мәртебе мен балл",
                    "status_score_and_review": "Мәртебе, балл және шолуға сілтеме"
                },
                "warnings": {
                    "limited_mode": "Шектеулі режим: балл мен қорытынды оқыту жүйесінде көрінбейді, тағайындауды тексеру орындалмайды.",
                    "connection_disabled": "Байланыс өшірілген: әкімші оны қайта қоспайынша, осы жарияланым бойынша іске қосулар мүлдем қабылданбайды.",
                    "assignment_check_off": "Ауыстырғыш өшірулі кезде курстың қайта тағайындалуы анықталмайды.",
                    "no_course_binding": "Жарияланым курсқа байланыстырылмаған — балл оқыту жүйесіне жетпейді."
                },
                "dialog": {
                    "connection_label": "Байланыс",
                    "scenario_label": "Сценарий",
                    "channel_label": "Жеткізу арнасы",
                    "channel_hint": "Топтамаға енгізілген, кейін өзгертілмейді.",
                    "status_label": "Мәртебе",
                    "status_hint": "Жарияланым ешқашан жойылмайды — ол өшіріледі. Содан кейін жаңа іске қосулардан бас тартылады, ал әлі жіберілмеген нәтижелер болдырылмайды.",
                    "settings_section": "Әрекет параметрлері",
                    "attempts_label": "Бір білім алушыға әрекеттер",
                    "attempts_unlimited": "Шексіз",
                    "daily_budget_label": "Бір білім алушыға тәулігіне іске қосулар",
                    "daily_budget_hint": "Квотаны сақтайды: басталған әрбір сұхбат есептен шығарылады және қайтарылмайды.",
                    "result_mode_label": "Оқыту жүйесіне не қайтарылады",
                    "pass_threshold_label": "Өту шегі, 0–100",
                    "result_wait_label": "Бағаны күту, сағат",
                    "result_wait_hint": "Одан кейін іске қосу «нәтиже жоқ» деп хабарлайды.",
                    "launch_limit_label": "Жалпы іске қосу шегі",
                    "launch_limit_hint": "Шегі болмаса, бос қалдырыңыз.",
                    "assignment_check_label": "Оқыту жүйесінде тағайындауды тексеру",
                    "binding_section": "Оқыту жүйесіндегі байланыстыру",
                    "external_course_label": "Курс идентификаторы",
                    "external_item_label": "Элемент идентификаторы",
                    "expires_label": "Жарияланым мерзімі",
                    "expires_hint": "Жарияланымның мерзімі болмаса, бос қалдырыңыз."
                },
                "key_dialog": {
                    "title": "Жарияланым жасалды",
                    "warning": "Кілт бір рет және тек осында көрсетіледі. Оны ешқайдан кері оқу мүмкін емес — қазір көшіріп алып, топтама параметрлеріне қойыңыз. Оны жоғалту жаңа жарияланым жасауды білдіреді.",
                    "key_label": "Жарияланым кілті",
                    "copied": "Көшірілді",
                    "package_hint": "Кілт топтаманың ішінде болғандықтан, оны ешқайда қоюдың қажеті жоқ. Топтаманы жүктеп алып, оқыту жүйесіне жүктеңіз. Оны кез келген уақытта «Жарияланымдар» бетінен қайта жүктеп алуға болады."
                },
                "messages": {
                    "saved": "Жарияланым сақталды",
                    "enabled": "Жарияланым қосылды",
                    "disabled": "Жарияланым өшірілді",
                    "download_failed": "Топтаманы жүктеп алу мүмкін болмады. Бетті жаңартып, қайта көріңіз."
                }
            },
            "journal": {
                "title": "Іске қосу журналы",
                "unknown_scenario": "Сценарий қолжетімсіз",
                "back": "Жарияланымдарға",
                "revoke": "Әрекетті қайтарып алу",
                "revoke_confirm": "Бұл әрекетті қайтарып алу керек пе? Білім алушы сұхбатқа қолжетімділігінен айырылады, ал жіберілмеген жеткізулер болдырылмайды.",
                "retry_delivery": "Қайталау",
                "empty_launches": "Іске қосулар әлі жоқ.",
                "empty_events": "Оқиғалар әлі жоқ.",
                "no_deliveries": "Бұл әрекетте жеткізулер жоқ.",
                "not_held_quota_charged": "Болмады, квота есептен шығарылды",
                "relaunches": "қайталанулар: {value}",
                "last_launch": "соңғы іске қосу: {value}",
                "result_deadline": "{value} дейін баға күтілуде",
                "learner_contacts": "Оқыту жүйесі жіберген мекенжай: {email}. Іске қосылған жер: {ip}",
                "score_passed": "{value} — өтті",
                "score_failed": "{value} — өтпеді",
                "tabs": {
                    "launches": "Әрекеттер",
                    "events": "Оқиғалар"
                },
                "headers": {
                    "learner": "Білім алушы",
                    "user": "Тіркелгі",
                    "attempt": "Әрекет",
                    "status": "Мәртебе",
                    "game": "Сұхбат",
                    "started_at": "Басталды",
                    "actions": " ",
                    "event_type": "Оқиға",
                    "refusal": "Себеп",
                    "request_proof": "Сұраным растамасы",
                    "ip": "Мекенжай",
                    "user_agent": "Клиент",
                    "happened_at": "Қашан"
                },
                "launch_status": {
                    "created": "Сілтеме берілді",
                    "started": "Жүріп жатыр",
                    "not_held": "Болмады",
                    "awaiting_result": "Баға күтілуде",
                    "result_ready": "Нәтиже жеткізілді",
                    "evaluation_failed": "Баға жоқ",
                    "result_timed_out": "Күту мерзімі аяқталды",
                    "assignment_changed": "Тағайындау өзгерді",
                    "revoked": "Қайтарылды"
                },
                "delivery": {
                    "version": "Нұсқа",
                    "status": "Мәртебе",
                    "outcome": "Қорытынды",
                    "result": "Нәтиже",
                    "score": "Балл",
                    "attempts": "Талпыныстар",
                    "last_attempt": "Соңғы талпыныс",
                    "external_state": "Оқыту жүйесіндегі күй"
                },
                "delivery_status": {
                    "pending": "Кезекте",
                    "in_progress": "Жіберілуде",
                    "done": "Дайын",
                    "needs_attention": "Назар аудару керек"
                },
                "delivery_outcome": {
                    "accepted": "Қабылданды",
                    "confirmed": "Расталды",
                    "rejected_by_external": "Қабылданбады",
                    "retry": "Қайталау жоспарланды",
                    "cancelled": "Бас тартылды",
                    "assignment_changed": "Тағайындау өзгерді"
                },
                "result": {
                    "passed": "Өтті",
                    "failed": "Өтпеді",
                    "not_held": "Болмады",
                    "no_result": "Нәтиже жоқ"
                },
                "refusal": {
                    "publication_disabled": "Жарияланым өшірілді",
                    "publication_draft": "Жарияланым әлі жоба",
                    "publication_expired": "Жарияланымның мерзімі өтті",
                    "feature_disabled": "Сыртқы іске қосу өшірілген",
                    "connection_disabled": "Байланыс өшірілген",
                    "launch_limit_reached": "Іске қосу шегіне жетті",
                    "daily_budget_exhausted": "Тәуліктік квота таусылды",
                    "attempts_exhausted": "Әрекеттер таусылды",
                    "quota_exhausted": "Ұйым квотасы таусылды",
                    "user_limit_reached": "Бос орын қалмады",
                    "scenario_unavailable": "Сценарий қолжетімсіз",
                    "assignment_check_unavailable": "Тағайындауды тексеру қолжетімсіз",
                    "code_invalid": "Сілтеме пайдаланылған немесе мерзімі өткен",
                    "channel_verification_failed": "Оқыту жүйесі сұранымды растамады",
                    "external_system_unavailable": "Оқыту жүйесі тағайындауды тексеруге жауап бермеді",
                    "user_not_found": "Бұл білім алушыға тіркелгі жоқ",
                    "user_unavailable": "Білім алушының тіркелгісі өшірілген",
                    "user_deleted": "Білім алушының тіркелгісі жойылған",
                    "email_taken_linking_disabled": "Электрондық пошта басқа тіркелгіге тиесілі",
                    "service_role_not_allowed": "Қызметтік тіркелгімен жаттығу мүмкін емес",
                    "unverified_request": "Сұраным расталмады"
                },
                "event_type": {
                    "launch_refused": "Іске қосудан бас тартылды",
                    "exchange_refused": "Сілтемеден бас тартылды",
                    "exchange_succeeded": "Сілтеме пайдаланылды"
                },
                "request_proof": {
                    "unverified": "Расталмаған",
                    "assignment_verified": "Тағайындау расталды"
                },
                "messages": {
                    "retry_queued": "Қайталау кезекке қойылды",
                    "revoked": "Әрекет қайтарылды"
                }
            }
        }
    },
    "voiceSession": {
        "mode": {
            "training": "Жаттығу",
            "interview": "Сұхбат"
        },
        "load": {
            "loading": "Сессия жүктелуде…",
            "failed": "Сессияны жүктеу мүмкін болмады. Байланысты тексеріп, қайта көріңіз.",
            "scenarioFailed": "Сценарий жүктелмеді",
            "scenarioRetry": "Қайталау"
        },
        "leave": {
            "confirm": "Сөйлесу әлі жалғасуда. Беттен шықсаңыз, ол аяқталмайды, ал уақыт жүре береді. Беттен шығасыз ба?",
            "confirmEnd": "Сөйлесу әлі жалғасуда. Кетсеңіз, ол аяқталады және үлгерген бөлігі бойынша бағаланады. Кетесіз бе?"
        },
        "elsewhere": {
            "interviewTitle": "Сұхбат басқа қойындыда ашық",
            "interviewText": "Сұхбат басқа қойындыда немесе басқа құрылғыда жалғасуда. Оны сол жерде жалғастырыңыз — бұл қойындыны жабуға болады.",
            "conversationTitle": "Сөйлесу басқа қойындыда ашық",
            "conversationText": "Сөйлесу басқа қойындыда немесе басқа құрылғыда жалғасуда. Оны сол жерде жалғастырыңыз — бұл қойындыны жабуға болады."
        },
        "prep": {
            "header": {
                "backToSessions": "Сессияларға",
                "themeToggleAriaLabel": "Тақырыпты ауыстыру"
            },
            "scenario": {
                "sectionLabel": "Сценарий",
                "competenceLabel": "Бағаланатын құзырет",
                "gameNumber": "Сессия #{number}",
                "duration": "{minutes} мин",
                "readFull": "Толығымен оқу",
                "generalLabel": "Жалпы ақпарат",
                "playerLabel": "Сізге арналған ақпарат"
            },
            "selfCamera": {
                "previewLabel": "Камераңыздың алдын ала көрінісі",
                "off": "Камера өшірулі"
            },
            "notes": {
                "empty": "Бос"
            },
            "start": {
                "button": "Сессияны бастау",
                "interviewButton": "Сұхбатты бастау",
                "resumeButton": "Сөйлесуге қайту",
                "resumeHint": "Сөйлесу әлдеқашан басталды — уақыт жүре береді."
            }
        },
        "equipment": {
            "status": {
                "checking": "Құрылғыларды тексеру",
                "waiting": "Рұқсатты күту",
                "denied": "Қол жеткізу тыйым салынған",
                "busy": "Құрылғы бос емес",
                "noCamera": "Камера жоқ",
                "missing": "Микрофон жоқ",
                "dismissed": "Рұқсат берілмеді",
                "ready": "Құрылғылар дайын"
            },
            "checking": {
                "title": "Микрофон мен камера тексерілуде…"
            },
            "waiting": {
                "title": "Микрофонға рұқсат беріңіз",
                "cameraTitle": "Камераға рұқсат беріңіз",
                "description": "Браузердің рұқсат сұрауы бет экранында ашық тұр. Микрофонсыз сөйлесуді бастау мүмкін емес."
            },
            "denied": {
                "title": "Браузер микрофонды бөгеп тұр",
                "cameraTitle": "Браузер камераны бөгеп тұр",
                "description": "Браузер тыйымды есте сақтап қалды. Сайт баптауларынан микрофонға рұқсат беріп, бетті жаңартыңыз.",
                "cameraDescription": "Браузер тыйымды есте сақтап қалды. Сайт баптауларынан камераға рұқсат беріп, бетті жаңартыңыз.",
                "showInstructions": "Қалай екенін көрсету",
                "hideInstructions": "Жасыру",
                "chromeEdge": {
                    "browser": "Chrome және Edge",
                    "text": "Мекенжай жолағының сол жағындағы құлып белгішесін басыңыз, \"Сайт баптаулары\" бөлімін ашып, \"Микрофон\" рұқсатын беріп, бетті жаңартыңыз."
                },
                "safari": {
                    "browser": "Safari",
                    "text": "Safari мәзірін ашыңыз → \"Осы веб-сайт үшін баптаулар\", \"Микрофон\" рұқсатын беріп, бетті жаңартыңыз."
                },
                "firefox": {
                    "browser": "Firefox",
                    "text": "Мекенжай жолағындағы микрофон белгішесін басыңыз, осы сайт үшін тыйымды алып тастап, бетті жаңартыңыз."
                },
                "system": {
                    "title": "Жүйеңіз браузерге микрофонды пайдалануға тыйым салады",
                    "cameraTitle": "Жүйеңіз браузерге камераны пайдалануға тыйым салады",
                    "macos": "macOS: Жүйе баптаулары → Құпиялылық және қауіпсіздік → Микрофон (немесе Камера) → браузеріңізді қосып, оны қайта іске қосыңыз.",
                    "windows": "Windows: Параметрлер → Құпиялылық және қауіпсіздік → Микрофон (немесе Камера) → қосымшалар мен браузеріңізге рұқсат беріп, \"Қайталау\" түймесін басыңыз."
                }
            },
            "busy": {
                "title": "Микрофонды басқа қолданба пайдаланып тұр",
                "cameraTitle": "Камераны басқа қолданба пайдаланып тұр",
                "description": "Әдетте бұл фондта қалып қойған қоңырау. Оны жауып, \"Қайталау\" түймесін басыңыз.",
                "retry": "Қайталау"
            },
            "noCamera": {
                "title": "Камера жоқ",
                "description": "Сізді есту мүмкін болады, бірақ көру мүмкін болмайды.",
                "requiredByScenario": "Бұл сөйлесу камераны талап етеді. Жалғастыру үшін камераны қосыңыз."
            },
            "missing": {
                "title": "Микрофон табылмады",
                "description": "Микрофонды жалғап, \"Қайталау\" түймесін басыңыз. Микрофонсыз сөйлесу басталмайды."
            },
            "dismissed": {
                "title": "Микрофонға рұқсат берілмеді",
                "cameraTitle": "Камераға рұқсат берілмеді",
                "description": "Браузер терезесі жауапсыз жабылды. \"Қайталау\" түймесін басып, рұқсат беріңіз."
            },
            "ready": {
                "title": "Құрылғылар дайын"
            },
            "micLabel": "Микрофон",
            "cameraLabel": "Камера",
            "chooseMic": "Микрофонды таңдау",
            "chooseCamera": "Камераны таңдау",
            "micLevelHint": "Бірдеңе айтыңыз",
            "speakerValue": "Динамик: {name}",
            "configure": "Баптау",
            "dialog": {
                "title": "Құрылғылар",
                "lockedDuringConversation": "Сөйлесу барысында құрылғыларды ауыстыру мүмкін емес.",
                "micSelectLabel": "Микрофон",
                "cameraSelectLabel": "Камера",
                "speakerSelectLabel": "Динамик",
                "noCameraOption": "Камерасыз",
                "record": "3 секунд жазу",
                "recording": "Жазылуда…",
                "recordFailed": "Жазу мүмкін болмады. Қайта көріңіз.",
                "listen": "Тыңдап көру",
                "playing": "Ойнатылуда…",
                "done": "Дайын",
                "closeAriaLabel": "Диалогты жабу"
            },
            "unnamed": {
                "microphone": "Микрофон {number}",
                "camera": "Камера {number}",
                "speaker": "Динамик {number}"
            },
            "cameraWarmup": {
                "preview": "Камера қосылып жатыр",
                "title": "Микрофон дайын",
                "description": "Камера жақын арада қосылады — әдетте бір-екі секунд.",
                "slowHint": "Камера қосылмай жатыр ма? «Баптау» арқылы басқасын таңдаңыз."
            }
        },
        "recording": {
            "videoAndAudio": "Сөйлесу мен бейне жазылып жатыр.",
            "audioOnly": "Сөйлесу жазылып жатыр.",
            "accessSelfAndEvaluators": "Жазба сізге және жұмысыңызды бағалайтын адамға қолжетімді.",
            "accessEvaluators": "Жазба жұмысыңызды бағалайтын адамға қолжетімді."
        },
        "scenario": {
            "video": "Сценарий авторынан бейне"
        },
        "notes": {
            "title": "Сессия ескертпелері",
            "placeholder": "Не жаттығу керек, қандай тіркестерді дайындадыңыз",
            "saving": "Сақталуда…",
            "saved": "Сақталды",
            "saveError": "Сақталмады",
            "visibility": "Ескертпелер сізге және сессияны бағалайтын адамға көрінеді.",
            "unsupported": "Бұл ескертпелерде мұнда өңделмейтін элементтер бар. Олар өзгеріссіз сақталған."
        },
        "stage": {
            "agentState": {
                "speaking": "Сөйлеп жатыр",
                "listening": "Тыңдап тұр",
                "thinking": "Ойлануда"
            },
            "micOffWarning": "Микрофон өшірулі — әңгімелесуші сізді естімейді",
            "micOnAriaLabel": "Микрофонды өшіру",
            "micOffAriaLabel": "Микрофонды қосу",
            "micOff": "Микрофон өшірулі",
            "micOnAnnouncement": "Микрофон қосулы",
            "captionsLabel": "Субтитрлер",
            "captionsOnAriaLabel": "Субтитрлерді жасыру",
            "captionsOffAriaLabel": "Субтитрлерді көрсету",
            "talkBalance": {
                "title": "Сөйлеу балансы",
                "you": "Сіз",
                "interlocutor": "Әңгімелесуші"
            },
            "connectionQuality": {
                "excellent": "Тамаша байланыс",
                "good": "Жақсы байланыс",
                "poor": "Байланыс әлсіз",
                "unknown": "Байланыс сапасы белгісіз"
            },
            "selfCameraLabel": "Сіз",
            "timeWarning": {
                "lastMinute": "Бір минут қалды — қорытындылауға уақыт",
                "finalSeconds": "15 секунд — ойыңызды аяқтаңыз"
            },
            "timeUp": {
                "title": "Уақыт бітті",
                "text": "Сөйлесу өздігінен жабылады, оны ұзарту мүмкін емес.",
                "closing": "Сөйлесу жабылуда…"
            },
            "voiceOnly": "Дауыстық режим — бұл сценарийде бейне жоқ",
            "interlocutorConnecting": {
                "title": "Әңгімелесуші қосылып жатыр",
                "hint": "Әдетте 2–4 секунд"
            },
            "layout": {
                "label": "Қатар",
                "sideTitle": "Қатар орналастыру",
                "focusTitle": "Әңгімелесушіні үлкейту"
            }
        },
        "panels": {
            "scenario": "Сценарий",
            "transcript": "Стенограмма",
            "transcriptEmpty": "Мұнда аяқталған репликалар пайда болады.",
            "notes": "Ескертпелер",
            "characterMemoryTab": "Кейіпкер не есте сақтайды",
            "openAriaLabel": "\"{panel}\" панелін ашу",
            "closeAriaLabel": "\"{panel}\" панелін жабу"
        },
        "sound": {
            "label": "Дыбыс",
            "volumeLabel": "Дыбыс деңгейі",
            "speakerLabel": "Динамик"
        },
        "end": {
            "button": "Аяқтау",
            "confirmTitle": "Сөйлесуді аяқтау керек пе?",
            "elapsed": "{total} ішінен {elapsed} өтті.",
            "partialEvaluationNotice": "Сөйлесу үлгерген бөлігі бойынша бағаланады.",
            "continue": "Жалғастыру",
            "notSent": "Сөйлесу уақыты бойынша аяқталады: сервер аяқтау сұрауына жауап бермеді."
        },
        "wait": {
            "title": "Сөйлесуді дайындап жатырмыз",
            "hint": "Әдетте бұл 1–3 минут алады. Бетті жаппаңыз — біз автоматты түрде бастаймыз.",
            "nextTry": "Келесі әрекет {time} кейін",
            "trying": "Бастап көріп жатырмыз…",
            "retrying": "Әзірге болмады. {time} кейін қайта көреміз",
            "cancel": "Бас тарту",
            "failed": {
                "title": "Сөйлесуді бастау мүмкін болмады",
                "text": "Қазір бос орын жоқ. Микрофон мен камера параметрлері сақталған — бірнеше минуттан кейін қайта көріңіз.",
                "retry": "Қайта көру"
            }
        },
        "connection": {
            "reconnecting": "Байланыс үзілді, қайта қосылуда…",
            "restored": "Байланыс қалпына келтірілді",
            "failed": "Байланысты қалпына келтіру мүмкін болмады",
            "retry": "Қайталау"
        },
        "hotkeys": {
            "title": "Пернелер тіркесімдері",
            "showHintAriaLabel": "Пернелер тіркесімдерін көрсету",
            "micToggle": "Микрофонды қосу/өшіру",
            "scenarioPanel": "Сценарий: панельді ашу және жабу",
            "transcriptPanel": "Стенограмма",
            "notesPanel": "Ескертпелер",
            "captionsToggle": "Субтитрлерді қосу/өшіру",
            "closeTopLayer": "Панельді, қалқымалы терезені немесе диалогты жабу",
            "endConfirm": "Аяқтау — растауды ашады",
            "showHint": "Осы кеңесті көрсету"
        },
        "intro": {
            "candidate": {
                "greeting": "Сәлеметсіз бе, {name}!",
                "leadWithVacancy": "{organization} сізді «{vacancy}» вакансиясы бойынша виртуалды әңгімелесушімен сұхбатқа шақырады.",
                "duration": "Сұхбат шамамен {minutes} минутке созылады.",
                "requirementsTitle": "Не қажет болады",
                "requirementMic": "Жұмыс істейтін микрофон, құлаққап болса — тіпті жақсы",
                "requirementCameraRequired": "Қосулы камера: бұл сұхбат үшін ол міндетті",
                "requirementCameraOptional": "Камера міндетті емес, бірақ онымен әңгіме анағұрлым табиғи өтеді",
                "requirementBrowser": "Компьютер және Chrome, Edge немесе Safari браузерінің жаңа нұсқасы",
                "requirementNetwork": "Тұрақты интернет-байланыс және ешкім бөлмейтін тыныш орын",
                "consentTextLabel": "Келісім мәтіні",
                "consentAccept": "Мәтінмен таныстым және дербес деректерімді өңдеуге келісім беремін",
                "next": "Келесі"
            },
            "launch": {
                "title": "Жаттығу сұхбаты",
                "lead": "Қазір сіз виртуалды әңгімелесушімен сөйлесесіз. Сұхбат жазылады және бағаланады, ал нәтиже сіздің оқыту жүйеңізге қайтарылады.",
                "requirementsTitle": "Не қажет болады",
                "requirementMic": "Жұмыс істейтін микрофон, жақсысы гарнитура",
                "requirementCamera": "Камера міндетті емес, бірақ онымен әңгіме жанданады",
                "requirementBrowser": "Жаңартылған Chrome, Edge немесе Safari бар компьютер",
                "requirementNetwork": "Тұрақты байланыс және сізге ешкім кедергі жасамайтын тыныш орын",
                "start": "Бастау"
            }
        },
        "finished": {
            "candidate": {
                "title": "Рахмет!",
                "text": "Сұхбат аяқталды. Нәтиже рекрутерге жіберіледі, ол сізбен байланысады. Бұл бетті қазір жабуға болады."
            },
            "launch": {
                "title": "Рахмет!",
                "text": "Сөйлесу аяқталды. Баға дайын болған соң нәтиже оқыту жүйеңізде пайда болады. Бұл бетті қазір жабуға болады."
            }
        },
        "closeDialogAriaLabel": "Диалогты жабу"
    },
    "loopAvatars": {
        "title": "Циклді аватарлар",
        "upload": "Аватар жүктеу",
        "newVersion": "Жаңа нұсқа",
        "newVersionHint": "«{name}», ағымдағы нұсқа {version}. Жаңа пакет осы аватары бар барлық профильдердегі бейнелерді ауыстырады.",
        "edit": "Аватарды өзгерту",
        "delete": "Аватарды жою",
        "empty": "Аватарлар әлі жоқ",
        "headers": {
            "poster": "Постер",
            "name": "Атауы",
            "gender": "Жынысы",
            "emotion": "Эмоция",
            "visibility": "Көріну",
            "version": "Нұсқа",
            "profiles": "Профильдер"
        },
        "gender": {
            "male": "Ер адам",
            "female": "Әйел"
        },
        "emotion": {
            "calm": "Сабырлы",
            "friendly": "Достық",
            "strict": "Қатал"
        },
        "visibility": {
            "all": "Барлық ұйымдар"
        },
        "fields": {
            "package": "Аватар пакеті (.zip)"
        },
        "packageHint": "manifest.json, listen.mp4, talk.mp4, transitions.json және poster.jpg бар 100 МБ-қа дейінгі ZIP",
        "validation": {
            "packageTooLarge": "Пакет 100 МБ-тан аспауы керек"
        },
        "errors": {
            "requestFailed": "Сұрау орындалмады. Қайталап көріңіз."
        },
        "confirmDetach": "Ажыратылатын профильдер: {count}. Олар фотоға ауысады. Сақтау керек пе?",
        "confirmDelete": "«{name}» аватарын жою керек пе?",
        "confirmDeleteWithProfiles": "«{name}» аватары профильдерде қолданылады: {count}. Олар фотоға ауысады. Жою керек пе?"
    },
    "ttsVoices": {
        "title": "TTS дыбыстары",
        "create": "Дыбыс қосу",
        "edit": "Дыбысты өзгерту",
        "delete": "Дыбысты жою",
        "replaceSample": "Үлгіні ауыстыру",
        "replaceSampleHint": "«{name}», үлгінің ағымдағы нұсқасы {version}. Жаңа үлгі осы дыбысы бар барлық профильдерде ойнатылады.",
        "empty": "Дыбыстар әлі жоқ",
        "play": "Үлгіні тыңдау",
        "stop": "Тоқтату",
        "headers": {
            "name": "Атауы",
            "provider": "Провайдер",
            "externalId": "Дыбыс ID",
            "gender": "Жынысы",
            "languages": "Тілдер",
            "visibility": "Көріну",
            "sample": "Үлгі",
            "profiles": "Профильдер"
        },
        "gender": {
            "male": "Ер адам",
            "female": "Әйел"
        },
        "visibility": {
            "all": "Барлық ұйымдар"
        },
        "fields": {
            "sample": "Дыбыс үлгісі",
            "speed": "Сөйлеу жылдамдығы"
        },
        "sampleHint": "MP3, MP4 немесе M4A, 5 МБ-қа дейін",
        "sampleOptionalHint": "Міндетті емес — үлгі дыбыс ID бойынша осы дыбыспен жасалады. MP3, MP4 немесе M4A, 5 МБ-қа дейін",
        "synthesizeSample": "Қайта генерациялау",
        "speedChangedHint": "Жаңа жылдамдықты есту үшін дыбыс үлгісін қайта генерациялаңыз.",
        "speedSamplePromptTitle": "Жылдамдық өзгертілді",
        "speedSamplePrompt": "Үлгі әлі де бұрынғы жылдамдықпен дыбысталады. Оны қайта генерациялайсыз ба? Қазіргі үлгі ауыстырылады.",
        "saveAndSynthesize": "Сақтау және генерациялау",
        "saveOnly": "Тек сақтау",
        "validation": {
            "sampleTooLarge": "Үлгі 5 МБ-тан аспауы керек"
        },
        "errors": {
            "requestFailed": "Сұрау орындалмады. Қайталап көріңіз.",
            "sampleUnavailable": "Үлгіні ойнату мүмкін болмады"
        },
        "confirmDetach": "Ажыратылатын профильдер: {count}. Олар қосылым дыбысына ауысады. Сақтау керек пе?",
        "confirmDelete": "«{name}» дыбысын жою керек пе?",
        "confirmDeleteWithProfiles": "«{name}» дыбысы профильдерде қолданылады: {count}. Олар қосылым дыбысына ауысады. Жою керек пе?",
        "picker": {
            "none": "Әдепкі дауыс",
            "empty": "Каталогта осы жынысқа арналған дыбыстар жоқ",
            "loadError": "Дыбыстарды жүктеу мүмкін болмады",
            "playSample": "Үлгіні тыңдау: {name}",
            "stopSample": "Үлгіні тоқтату: {name}",
            "sampleUnavailable": "Үлгі қолжетімсіз"
        }
    },
    "realtimeAvatars": {
        "title": "Live-аватарлар",
        "create": "Аватар қосу",
        "edit": "Аватарды өзгерту",
        "delete": "Аватарды жою",
        "preview": "Алдын ала қарауды көру",
        "empty": "Аватарлар әлі жоқ",
        "headers": {
            "poster": "Постер",
            "name": "Атауы",
            "provider": "Провайдер",
            "externalId": "Аватар ID",
            "gender": "Жынысы",
            "visibility": "Көрінуі",
            "profiles": "Профильдер",
            "models": "Anam модельдері"
        },
        "gender": {
            "male": "Ер",
            "female": "Әйел"
        },
        "visibility": {
            "all": "Барлық ұйымдар"
        },
        "nameHint": "Міндетті емес — Anam-дағы атау қолданылады",
        "externalIdHint": "ID өзгертілсе, постер мен алдын ала қарау Anam-нан қайта жүктеледі",
        "errors": {
            "requestFailed": "Сұрау орындалмады. Қайталап көріңіз.",
            "previewUnavailable": "Алдын ала қарауды ойнату мүмкін болмады"
        },
        "confirmDetach": "Ажыратылатын профильдер: {count}. Олар фотоға ауысады. Сақтау керек пе?",
        "confirmDelete": "«{name}» аватарын жою керек пе?",
        "confirmDeleteWithProfiles": "«{name}» аватары профильдерде қолданылады: {count}. Олар фотоға ауысады. Жою керек пе?",
        "picker": {
            "label": "Live-аватарлар",
            "empty": "Бұл профиль үшін қолжетімді Live-аватарлар жоқ",
            "emptyFiltered": "Осы жыныстағы Live-аватарлар жоқ",
            "loadError": "Live-аватарларды жүктеу мүмкін болмады"
        }
    },
    "aiProfileAppearance": {
        "label": "Сыртқы түрі",
        "photo": "Өз фотоңыз",
        "avatar": "Studio",
        "live": "Live",
        "mascot": "Маскот",
        "filterGender": "Жынысы",
        "filterEmotion": "Эмоция",
        "avatarsLabel": "Аватарлар",
        "avatarRequired": "Аватарды таңдаңыз",
        "liveRequired": "Live-аватарды таңдаңыз",
        "livePlaceholder": "Live-аватарыңыз осы жерде көрінеді",
        "empty": "Бұл профиль үшін қолжетімді аватарлар жоқ",
        "emptyFiltered": "Сүзгілерге сәйкес аватарлар жоқ",
        "loadError": "Аватарларды жүктеу мүмкін болмады",
        "playPreview": "Алдын ала қарауды ойнату: {name}",
        "pausePreview": "Алдын ала қарауды тоқтату: {name}"
    },
  "emailStopList": {
    "title": "Email стоп-тізімі",
    "description": "Бұл мекенжайларға және домендерге хаттар жіберілмейді. Доменнің жазбасы сол доменнің барлық мекенжайларын қамтиды, бірақ оның субдомендерін қамтымайды.",
    "searchPlaceholder": "Мекенжай немесе домен бойынша іздеу",
    "allReasons": "Барлық себептер",
    "add": "Қосу",
    "addTitle": "Мекенжайды немесе доменді бұғаттау",
    "empty": "Стоп-тізім бос",
    "editNote": "Ескертпені өзгерту",
    "headers": {
      "type": "Түрі",
      "value": "Мекенжай немесе домен",
      "reason": "Себебі",
      "providerReply": "Пошта қызметінің жауабы",
      "note": "Ескертпе",
      "author": "Кім қосты",
      "createdAt": "Қосылған күні",
      "blockedCount": "Тоқтатылған хаттар",
      "lastBlockedAt": "Соңғы тоқтатылған"
    },
    "type": {
      "address": "Мекенжай",
      "domain": "Домен"
    },
    "reason": {
      "manual": "Қолмен қосылған",
      "providerRejected": "Пошта қызметі қабылдамады"
    },
    "author": {
      "system": "Жүйе"
    },
    "fields": {
      "value": "Мекенжай немесе домен",
      "valueHint": "Мекенжайды толық немесе тек доменді көрсетіңіз. Домен өзінің барлық мекенжайын бұғаттайды, бірақ субдомендерді бұғаттамайды.",
      "note": "Ескертпе"
    },
    "errors": {
      "requestFailed": "Әрекетті орындау мүмкін болмады. Қайталап көріңіз."
    },
    "unblock": {
      "action": "Бұғаттан шығару",
      "confirm": "{value} бұғатын алып тастау керек пе?",
      "resultTitle": "Бұғаттан шығару нәтижесі",
      "result": {
        "removedEverywhere": "Бұғаттан шығарылды. Пошта қызметінің стоп-тізімінде бұл мекенжай жоқ, сондықтан хаттар қайтадан жіберіледі.",
        "removedLocally": "Домен бұғаттан шығарылды. Осы доменнің өз жазбасы бар мекенжайлары бұғатталған күйінде қалады.",
        "providerNotConfigured": "Тек платформаның жазбасы алынды: пошта қызметімен байланыс бапталмаған, сондықтан оның стоп-тізімі тексерілмеді.",
        "providerUnavailable": "Пошта қызметі қолжетімсіз, кейінірек қайталаңыз. Мекенжай әзірге бұғатталған күйінде.",
        "stillListedAtProvider": "Мекенжай пошта қызметінің стоп-тізімінде тұр. Оны қызмет панелінен алып тастап, «Қайта бұғаттан шығару» түймесін басыңыз. Егер панельде мекенжай жоқ болса, ол қызметтің жаһандық стоп-тізімінде тұр, одан алып тастау мүмкін емес."
      },
      "openPanel": "Пошта қызметінің панелін ашу",
      "panelPath": "Қайдан алып тастау: пошта қызметінің панелі → Products → Email Service → сіздің ресурсыңыз → Stop Lists қойындысы.",
      "retry": "Қайта бұғаттан шығару"
    },
    "suggestions": {
      "text": "{domain} доменінде бұғатталған мекенжай саны: {count}. Бүкіл доменді бұғаттау керек пе?",
      "block": "Доменді бұғаттау",
      "confirm": "{domain} доменін бұғаттау керек пе? Оның барлық мекенжайына хаттар жіберілмейтін болады. Субдомендерге әсер етпейді, жеке мекенжайлардың жазбалары сақталады."
    },
    "check": {
      "title": "Мекенжайды тексеру",
      "hint": "Мекенжайға хаттарды платформа немесе пошта қызметі бұғаттайтынын көрсетеді",
      "placeholder": "Email мекенжайы",
      "submit": "Тексеру",
      "resultFor": "{email} нәтижесі",
      "platform": "Платформаның стоп-тізімі",
      "platformListed": "Иә — «{value}» жазбасы",
      "provider": "Пошта қызметінің стоп-тізімі",
      "listed": "Иә",
      "notListed": "Жоқ",
      "providerReasons": "Пошта қызметі көрсеткен себептер:",
      "providerNotConfigured": "Пошта қызметімен байланыс бапталмаған",
      "providerUnavailable": "Пошта қызметі қолжетімсіз, кейінірек қайталаңыз"
    }
  }
}
